/* global __app_id, __firebase_config, __initial_auth_token */
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { initializeApp } from 'firebase/app';
import { getAuth, signInAnonymously, signInWithCustomToken, onAuthStateChanged } from 'firebase/auth';
import { getFirestore, collection, doc, onSnapshot, getDocs, setDoc, query, updateDoc, deleteDoc, where } from 'firebase/firestore'; // 'where' eklendi
import { RefreshCw, LayoutDashboard, Settings, BarChart2, History, List, LogOut, Send, CheckCircle, Plus, Edit2, Zap, Sparkles, HardHat, UserCheck, PlayCircle, Trash2, AlertTriangle, Users, Cpu, Filter, Search, Lock, User, Eye, EyeOff, StickyNote, Save } from 'lucide-react'; // YENİ: StickyNote ve Save eklendi

// --- CONFIGURATION & CONSTANTS ---
const appId = typeof __app_id !== 'undefined' ? __app_id : 'kalo-83d81';
// Import the functions you need from the SDKs you need
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAIrJUlIPxSCzr94CxbCU1W6ch3KA5ExDs",
  authDomain: "kalo-83d81.firebaseapp.com",
  projectId: "kalo-83d81",
  storageBucket: "kalo-83d81.firebasestorage.app",
  messagingSenderId: "252608960551",
  appId: "1:252608960551:web:30e7956cf4b3c02a2d9602",
  measurementId: "G-7J095C1G2Y"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const initialAuthToken = typeof __initial_auth_token !== 'undefined' ? __initial_auth_token : null;

// --- DÜZELTME: EKSİK SABİTLER EKLENDİ ---
const PROJECT_COLLECTION = `artifacts/${appId}/public/data/moldProjects`;
const PERSONNEL_COLLECTION = `artifacts/${appId}/public/data/personnel`;
const MACHINES_COLLECTION = `artifacts/${appId}/public/data/machines`;
const MOLD_NOTES_COLLECTION = `artifacts/${appId}/public/data/moldNotes`; // YENİ: Notlar için
// --- DÜZELTME SONU ---

// Kullanıcı rolleri (Giriş yapabilen roller)
const ROLES = {
    ADMIN: 'Yönetici',
    CAM_OPERATOR: 'CAM Operatörü',
    SUPERVISOR: 'Kalıphane Yetkilisi',
};

// Personel Rolleri (Tüm roller)
const PERSONNEL_ROLES = {
    ADMIN: 'Yönetici',
    CAM_OPERATOR: 'CAM Operatörü',
    SUPERVISOR: 'Kalıphane Yetkilisi',
    MACHINE_OPERATOR: 'Tezgah Operatörü'
};

// Operatör listeleri (Başlangıçta boş, Firestore'dan doldurulacak)
let CAM_OPERATORS = [];
let MACHINE_OPERATORS = [];
let AVAILABLE_MACHINES = ['K40', 'K68', 'K70', 'Fİ-200', 'AG-500', 'DECKEL-50'];

// YENİ: Operasyon Durumları (Eski Parça Durumları)
const OPERATION_STATUS = {
    NOT_STARTED: 'BAŞLAMADI',
    IN_PROGRESS: 'ÇALIŞIYOR',
    WAITING_SUPERVISOR_REVIEW: 'YETKİLİ DEĞERLENDİRMESİ BEKLİYOR',
    COMPLETED: 'TAMAMLANDI',
};

// YENİ: Operasyon Tipleri
const OPERATION_TYPES = {
    CNC: 'CNC',
    AYNA_POLISAJ: 'AYNA POLİSAJ',
    EROZYON_DESEN: 'EROZYON DESEN',
    ASIT_DESEN: 'ASİT DESEN',
    KUM_PARLATMA_600: '600 KUM PARLATMA',
    TAKIM_IZI_POLISAJ: 'TAKIM İZİ POLİSAJ',
};

// Adminin ekleyebileceği operasyon tipleri (CNC hariç)
const ADDABLE_OPERATION_TYPES = {
    AYNA_POLISAJ: 'AYNA POLİSAJ',
    EROZYON_DESEN: 'EROZYON DESEN',
    ASIT_DESEN: 'ASİT DESEN',
    KUM_PARLATMA_600: '600 KUM PARLATMA',
    TAKIM_IZI_POLISAJ: 'TAKIM İZİ POLİSAJ',
};


// YENİ: Kalıp Ana Durumları (Manuel Admin Kontrolü)
// "AKTİF" kaldırıldı, detaylı aşamalar eklendi.
const MOLD_STATUS = {
    WAITING: 'BEKLEMEDE',
    CNC: 'CNC', // YENİ EKLENDİ
    EREZYON: 'EREZYON',
    POLISAJ: 'POLİSAJ',
    DESEN: 'DESEN',
    MOLD_ASSEMBLY: 'KALIP MONTAJ',
    TRIAL: 'DENEME\'DE',
    REVISION: 'REVİZYON',
    COMPLETED: 'TAMAMLANDI',
};

// "Aktif" sayılan durumların listesi (filtreleme için)
const MOLD_STATUS_ACTIVE_LIST = [
    MOLD_STATUS.CNC, // YENİ EKLENDİ
    MOLD_STATUS.EREZYON,
    MOLD_STATUS.POLISAJ,
    MOLD_STATUS.DESEN,
    MOLD_STATUS.MOLD_ASSEMBLY,
    MOLD_STATUS.TRIAL,
    MOLD_STATUS.REVISION,
];


// Haritalama fonksiyonu (Sadece seed için)
// GÜNCELLEME: Artık sadece BEKLEMEDE veya TAMAMLANDI olarak ayarlar
const mapTaskStatusToMoldStatus = (taskStatus) => {
    switch(taskStatus) {
        case OPERATION_STATUS.COMPLETED:
            return MOLD_STATUS.COMPLETED;
        // Diğer tüm durumlar (IN_PROGRESS, NOT_STARTED vs.) BEKLEMEDE başlar
        case OPERATION_STATUS.NOT_STARTED:
        case OPERATION_STATUS.IN_PROGRESS:
        case OPERATION_STATUS.WAITING_SUPERVISOR_REVIEW:
            return MOLD_STATUS.WAITING;
        default:
            return MOLD_STATUS.WAITING;
    }
};

// --- YENİ: SİMÜLASYON VERİSİ İÇİN TARİH OLUŞTURUCU ---
const getDateDaysAgo = (days) => {
    const date = new Date(Date.now() - days * 24 * 60 * 60 * 1000);
    return date.toISOString();
};


// Örnek Görevler (Veritabanı boşsa eklenecek)
// GÜNCELLEME: `status` ve `moldDeadline` alanı eklendi
// GÜNCELLEME 2: 'tasks' artık 'operations' dizisi içeriyor
const initialProjects = [
    {
        id: 'mold-1', moldName: '2847 FAN SHIELD RIGHT', customer: 'AGCO', 
        status: MOLD_STATUS.EREZYON, // Manuel olarak ayarlandı
        moldDeadline: new Date(Date.now() + 10 * 24 * 60 * 60 * 1000).toISOString().split('T')[0], // 10 gün sonrası
        tasks: [
            { id: 'task-1-1', taskName: 'ANA GÖVDE SOL', taskNumber: 1, operations: [
                // Operasyon 1 (CNC)
                { id: 'op-1-1-1', type: OPERATION_TYPES.CNC, assignedOperator: 'SEÇ', machineName: '', status: OPERATION_STATUS.NOT_STARTED, progressPercentage: 0, machineOperatorName: '', estimatedDueDate: '', startDate: '', finishDate: '', durationInHours: null, supervisorRating: null, supervisorReviewDate: null, supervisorComment: null, camOperatorRatingForMachineOp: null, camOperatorCommentForMachineOp: null, camOperatorReviewDate: null }
            ]},
            { id: 'task-1-2', taskName: 'SICAK YOLLUK NOZZLE', taskNumber: 2, operations: [
                // Operasyon 1 (CNC)
                { id: 'op-1-2-1', type: OPERATION_TYPES.CNC, assignedOperator: 'Emre Bey (CAM)', machineName: 'K70', machineOperatorName: 'Ali Yılmaz', status: OPERATION_STATUS.IN_PROGRESS, progressPercentage: 50, estimatedDueDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0], startDate: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(), finishDate: '', durationInHours: null, supervisorRating: null, supervisorReviewDate: null, supervisorComment: null, camOperatorRatingForMachineOp: null, camOperatorCommentForMachineOp: null, camOperatorReviewDate: null }
            ]},
        ]
    },
    {
        id: 'mold-2', moldName: 'YENİ KALIP PROJESİ A', customer: 'DEMO', 
        status: MOLD_STATUS.WAITING, // Manuel olarak ayarlandı
        moldDeadline: '', // Termin belirlenmemiş
        tasks: [
            { id: 'task-2-1', taskName: 'ANA İŞ PARÇASI', taskNumber: 1, operations: [
                { id: 'op-2-1-1', type: OPERATION_TYPES.CNC, assignedOperator: 'SEÇ', machineName: '', status: OPERATION_STATUS.NOT_STARTED, progressPercentage: 0, machineOperatorName: '', estimatedDueDate: '', startDate: '', finishDate: '', durationInHours: null, supervisorRating: null, supervisorReviewDate: null, supervisorComment: null, camOperatorRatingForMachineOp: null, camOperatorCommentForMachineOp: null, camOperatorReviewDate: null }
            ]},
            { id: 'task-2-2', taskName: 'TEST PLAKASI', taskNumber: 2, operations: [
                { id: 'op-2-2-1', type: OPERATION_TYPES.CNC, assignedOperator: 'Can Bey (CAM)', machineName: 'K40', machineOperatorName: 'Burak Demir', status: OPERATION_STATUS.WAITING_SUPERVISOR_REVIEW, progressPercentage: 100, estimatedDueDate: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString().split('T')[0], startDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(), finishDate: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(), durationInHours: 96.0, supervisorRating: null, supervisorReviewDate: null, supervisorComment: null, camOperatorRatingForMachineOp: 8, camOperatorCommentForMachineOp: "Hazırlık iyiydi", camOperatorReviewDate: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString() }
            ]},
        ]
    },
    // --- YENİ SİMÜLASYON VERİSİ ---
    {
        id: 'mold-sim-1', moldName: 'SIMULASYON KALIBI 1 (Son 30 Gün)', customer: 'SİMÜLASYON', 
        status: MOLD_STATUS.COMPLETED,
        moldDeadline: getDateDaysAgo(5), // 5 gün geçmiş termin
        tasks: [
            // SİM-ANA GÖVDE (2 Operasyonlu)
            { id: 'task-sim-1-1', taskName: 'SİM-ANA GÖVDE', taskNumber: 1, operations: [
                // Op 1: CNC (Tamamlandı)
                { id: 'op-sim-1-1-1', type: OPERATION_TYPES.CNC, assignedOperator: 'Emre Bey (CAM)', machineName: 'K70', machineOperatorName: 'Ali Yılmaz', 
                  status: OPERATION_STATUS.COMPLETED, progressPercentage: 100, 
                  estimatedDueDate: getDateDaysAgo(10), startDate: getDateDaysAgo(15), finishDate: getDateDaysAgo(7), 
                  durationInHours: 120.5,
                  camOperatorRatingForMachineOp: 9, camOperatorCommentForMachineOp: "Süper, hızlı ve temiz iş.", camOperatorReviewDate: getDateDaysAgo(7),
                  supervisorRating: 10, supervisorReviewDate: getDateDaysAgo(6), supervisorComment: "Mükemmel hız, teşekkürler Emre."
                },
                // Op 2: EREZYON (Tamamlandı)
                { id: 'op-sim-1-1-2', type: OPERATION_TYPES.EROZYON_DESEN, assignedOperator: 'Emre Bey (CAM)', machineName: 'AG-500', machineOperatorName: 'Ali Yılmaz', 
                  status: OPERATION_STATUS.COMPLETED, progressPercentage: 100, 
                  estimatedDueDate: getDateDaysAgo(2), startDate: getDateDaysAgo(5), finishDate: getDateDaysAgo(1), 
                  durationInHours: 96.0,
                  camOperatorRatingForMachineOp: 10, camOperatorCommentForMachineOp: "Ali Bey yine harika.", camOperatorReviewDate: getDateDaysAgo(1),
                  supervisorRating: 10, supervisorReviewDate: getDateDaysAgo(0), supervisorComment: "Çok hızlısınız."
                }
            ]},
            // SİM-İTİCİ PLAKA (Tek Operasyonlu)
            { id: 'task-sim-1-2', taskName: 'SİM-İTİCİ PLAKA', taskNumber: 2, operations: [
                { id: 'op-sim-1-2-1', type: OPERATION_TYPES.CNC, assignedOperator: 'Can Bey (CAM)', machineName: 'K40', machineOperatorName: 'Burak Demir', 
                  status: OPERATION_STATUS.COMPLETED, progressPercentage: 100, 
                  estimatedDueDate: getDateDaysAgo(5), startDate: getDateDaysAgo(12), finishDate: getDateDaysAgo(4), 
                  durationInHours: 192.0,
                  camOperatorRatingForMachineOp: 7, camOperatorCommentForMachineOp: "İş bitti ama tezgah hazırlığı biraz yavaştı.", camOperatorReviewDate: getDateDaysAgo(4),
                  supervisorRating: 8, supervisorReviewDate: getDateDaysAgo(2), supervisorComment: "İyi iş, terminlere dikkat."
                }
            ]},
        ]
    },
    {
        id: 'mold-sim-2', moldName: 'SIMULASYON KALIBI 2 (Eski Veri)', customer: 'SİMÜLASYON', 
        status: MOLD_STATUS.COMPLETED,
        moldDeadline: getDateDaysAgo(50), // 50 gün geçmiş termin
        tasks: [
            { id: 'task-sim-2-1', taskName: 'SİM-ESKİ PARÇA 1', taskNumber: 1, operations: [
                { id: 'op-sim-2-1-1', type: OPERATION_TYPES.CNC, assignedOperator: 'Emre Bey (CAM)', machineName: 'K68', machineOperatorName: 'Deniz Kaya', 
                  status: OPERATION_STATUS.COMPLETED, progressPercentage: 100, 
                  estimatedDueDate: getDateDaysAgo(70), startDate: getDateDaysAgo(80), finishDate: getDateDaysAgo(65), 
                  durationInHours: 360.0,
                  camOperatorRatingForMachineOp: 10, camOperatorCommentForMachineOp: "Deniz Hanım ile çalışmak çok verimli.", camOperatorReviewDate: getDateDaysAgo(65),
                  supervisorRating: 9, supervisorReviewDate: getDateDaysAgo(64), supervisorComment: "Güzel iş, süre biraz uzun ama parça zordu."
                }
            ]},
            { id: 'task-sim-2-2', taskName: 'SİM-ESKİ PARÇA 2', taskNumber: 2, operations: [
                { id: 'op-sim-2-2-1', type: OPERATION_TYPES.CNC, assignedOperator: 'Can Bey (CAM)', machineName: 'K68', machineOperatorName: 'Deniz Kaya', 
                  status: OPERATION_STATUS.COMPLETED, progressPercentage: 100, 
                  estimatedDueDate: getDateDaysAgo(60), startDate: getDateDaysAgo(65), finishDate: getDateDaysAgo(55), 
                  durationInHours: 240.0,
                  camOperatorRatingForMachineOp: 9, camOperatorCommentForMachineOp: "", camOperatorReviewDate: getDateDaysAgo(55),
                  supervisorRating: 7, supervisorReviewDate: getDateDaysAgo(55), supervisorComment: "Termine uyuldu."
                }
            ]},
        ]
    }
    // --- SİMÜLASYON VERİSİ SONU ---
];

// --- FIREBASE UTILITIES ---
// (Sabitler)

// Helper functions for date/time
const formatDateTime = (isoString) => isoString ? new Date(isoString).toLocaleString('tr-TR', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '---';
const formatDate = (isoString) => isoString ? new Date(isoString).toLocaleDateString('tr-TR', { day: '2-digit', month: 'short', year: 'numeric' }) : '---';
const getCurrentDateTimeString = () => new Date().toISOString();

/**
 * YENİ: Kalan iş günlerini hesaplar (Pazar günleri hariç)
 * @param {string} deadlineString - "YYYY-MM-DD" formatında termin tarihi
 * @returns {number|null} Kalan iş günü sayısı (pozitif), geçmiş iş günü sayısı (negatif), 0 (termin bugün) veya null (tarih yoksa).
 */
const calculateRemainingWorkDays = (deadlineString) => {
    // ... (Mevcut fonksiyon - değişiklik yok)
    if (!deadlineString) return null;

    try {
        const deadlineDate = new Date(deadlineString);
        const today = new Date();
        
        deadlineDate.setHours(23, 59, 59, 999);
        today.setHours(0, 0, 0, 0); 

        if (isNaN(deadlineDate.getTime())) {
            return null;
        }

        let workDays = 0;
        
        if (deadlineDate < today) {
            let currentDate = new Date(deadlineDate);
            currentDate.setDate(currentDate.getDate() + 1); 
            
            while(currentDate <= today) {
                if (currentDate.getDay() !== 0) {
                    workDays++;
                }
                currentDate.setDate(currentDate.getDate() + 1);
            }
            return -workDays; 
        } else {
            let currentDate = new Date(today);
            
            if (currentDate.getTime() === deadlineDate.getTime() && currentDate.getDay() !== 0) {
                 return 0;
            }
            
            currentDate.setDate(currentDate.getDate() + 1); 

            while(currentDate <= deadlineDate) {
                if (currentDate.getDay() !== 0) {
                    workDays++;
                }
                currentDate.setDate(currentDate.getDate() + 1);
            }
            return workDays;
        }
        
    } catch (e) {
        console.error("İş günü hesaplama hatası:", e);
        return null;
    }
};


/**
 * Görev Durumlarına göre renk sınıflarını döndürür.
 * GÜNCELLEME: MOLD_STATUS durumlarını da içerecek şekilde genişletildi.
 * GÜNCELLEME 2: Artık OPERATION_STATUS kullanıyor
 */
const getStatusClasses = (status) => {
    switch (status) {
        // OPERASYON DURUMLARI
        case OPERATION_STATUS.NOT_STARTED:
            return 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300';
        case OPERATION_STATUS.IN_PROGRESS:
            return 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300';
        case OPERATION_STATUS.WAITING_SUPERVISOR_REVIEW:
            return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300 animate-pulse';
        case OPERATION_STATUS.COMPLETED:
            return 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300';
        
        // KALIP ANA DURUMLARI
        case MOLD_STATUS.WAITING:
            return 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300';
        case MOLD_STATUS.CNC:
        case MOLD_STATUS.EREZYON:
        case MOLD_STATUS.POLISAJ:
        case MOLD_STATUS.DESEN:
        case MOLD_STATUS.MOLD_ASSEMBLY:
        case MOLD_STATUS.TRIAL:
        case MOLD_STATUS.REVISION:
            return 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300';
        case MOLD_STATUS.COMPLETED:
            return 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300';
            
        default:
            return 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200';
    }
};

/**
 * YENİ: İki tarih arasındaki iş günü farkını hesaplar (Pazar hariç).
 * @param {string} completionDateString - ISO formatında tamamlanma tarihi
 * @param {string} deadlineString - "YYYY-MM-DD" formatında termin tarihi
 * @returns {number|null} 
 */
const calculateWorkDayDifference = (completionDateString, deadlineString) => {
    // ... (Mevcut fonksiyon - değişiklik yok)
    if (!completionDateString || !deadlineString) return null;

    try {
        const completionDate = new Date(completionDateString);
        const deadlineDate = new Date(deadlineString);

        completionDate.setHours(0, 0, 0, 0);
        deadlineDate.setHours(0, 0, 0, 0); 

        if (isNaN(completionDate.getTime()) || isNaN(deadlineDate.getTime())) {
            return null;
        }

        if (completionDate.getTime() === deadlineDate.getTime()) {
            return 0;
        }

        let workDays = 0;
        
        if (completionDate < deadlineDate) {
            let currentDate = new Date(completionDate);
            currentDate.setDate(currentDate.getDate() + 1);

            while(currentDate <= deadlineDate) {
                if (currentDate.getDay() !== 0) {
                    workDays++;
                }
                currentDate.setDate(currentDate.getDate() + 1);
            }
            return workDays;

        } else {
            let currentDate = new Date(deadlineDate);
            currentDate.setDate(currentDate.getDate() + 1);
            
            while(currentDate <= completionDate) {
                if (currentDate.getDay() !== 0) {
                    workDays++;
                }
                currentDate.setDate(currentDate.getDate() + 1);
            }
            return -workDays;
        }
        
    } catch (e) {
        console.error("İş günü farkı hesaplama hatası:", e);
        return null;
    }
};


/**
 * Gemini API'ye istek atmak için merkezi fonksiyon
 */
const callGeminiApi = async (userQuery, systemInstruction = null, jsonSchema = null, maxRetries = 3) => {
    // ... (Mevcut fonksiyon - değişiklik yok)
    const apiKey = "";
    const apiUrl = `https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash-preview-09-2025:generateContent?key=${apiKey}`;

    const payload = {
        contents: [{ parts: [{ text: userQuery }] }],
    };

    if (systemInstruction) {
        payload.systemInstruction = {
            parts: [{ text: systemInstruction }]
        };
    }

    if (jsonSchema) {
        payload.generationConfig = {
            responseMimeType: "application/json",
            responseSchema: jsonSchema,
        };
    }

    let attempt = 0;
    while (attempt < maxRetries) {
        try {
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error(`API isteği başarısız oldu: ${response.status} ${response.statusText}`);
            }

            const result = await response.json();
            const candidate = result.candidates?.[0];

            if (candidate && candidate.content?.parts?.[0]?.text) {
                return candidate.content.parts[0].text;
            } else {
                throw new Error("API'den beklenen formatta cevap alınamadı.");
            }

        } catch (error) {
            console.error(`Gemini API çağrı hatası (Deneme ${attempt + 1}/${maxRetries}):`, error);
            attempt++;
            if (attempt >= maxRetries) {
                return `Hata: ${error.message}`;
            }
            await new Promise(resolve => setTimeout(resolve, Math.pow(2, attempt) * 1000));
        }
    }
    return "Hata: Maksimum yeniden deneme sayısına ulaşıldı.";
};

/**
 * Modal Component
 */
const Modal = ({ isOpen, onClose, title, children }) => {
    // ... (Mevcut fonksiyon - değişiklik yok)
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-75 z-50 flex justify-center items-center p-4">
            <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto transform transition-all duration-300">
                <div className="p-6 border-b dark:border-gray-700 flex justify-between items-center">
                    <h3 className="text-xl font-bold text-gray-900 dark:text-white">{title}</h3>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
                        &times;
                    </button>
                </div>
                <div className="p-6">
                    {children}
                </div>
            </div>
        </div>
    );
};

// --- YENİ: ÇALIŞAN PARÇALAR SAYFASI (GÜNCELLENDİ) ---

/**
 * Çalışan Parçalar Listesi - Tüm kullanıcılar için
 * GÜNCELLEME: Artık operasyonları listeliyor
 */
const ActiveTasksPage = ({ projects, machines, loggedInUser, personnel }) => {
    const [searchTerm, setSearchTerm] = useState('');
    
    // Süreyi formatlayan yardımcı fonksiyon
    const formatDuration = (startDate) => {
        // ... (Mevcut fonksiyon - değişiklik yok)
        if (!startDate) return '---';
        const start = new Date(startDate);
        const now = new Date();
        const diffMs = now - start;
        const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
        if (diffHours < 24) return `${diffHours} saat`;
        const days = Math.floor(diffHours / 24);
        const hours = diffHours % 24;
        return `${days}gün ${hours}saat`;
    };

    const lowerSearchTerm = searchTerm.toLowerCase();

    // GÜNCELLEME: Tüm 'ÇALIŞIYOR' operasyonlarını bul
    const allRunningOperations = useMemo(() => {
        return projects.flatMap(mold => 
            mold.tasks.flatMap(task => 
                task.operations
                    .filter(op => op.status === OPERATION_STATUS.IN_PROGRESS)
                    .map(op => ({
                        ...op,
                        moldName: mold.moldName,
                        moldCustomer: mold.customer,
                        taskName: task.taskName, // Ana parçanın adını ekle
                    }))
            )
        );
    }, [projects]);


    // YENİ LİSTE 1: TEZGAH DURUMLARI (GÜNCELLENDİ)
    const machineStatusList = useMemo(() => {
        const allMachineNames = machines.map(m => m.name);
        
        // Çalışan operasyonları map'le
        const runningTasksMap = new Map();
        allRunningOperations.forEach(op => {
            if(op.machineName) {
                runningTasksMap.set(op.machineName, op);
            }
        });

        // Durum listesini oluştur
        const statusList = allMachineNames.map(machineName => {
            const runningTask = runningTasksMap.get(machineName);
            if (runningTask) {
                return { machineName: machineName, isIdle: false, task: runningTask }; // 'task' prop'u artık 'operation' objesi
            } else {
                return { machineName: machineName, isIdle: true, task: null };
            }
        });

        // YENİ: İsteğe göre sırala (Önce Çalışanlar, sonra Boşta olanlar)
        statusList.sort((a, b) => {
            if (a.isIdle && !b.isIdle) return 1;  // a (boşta) sonraya
            if (!a.isIdle && b.isIdle) return -1; // a (çalışıyor) öne
            return a.machineName.localeCompare(b.machineName); // Kendi içlerinde isme göre sırala
        });

        // Filtrele
        if (!searchTerm.trim()) return statusList;

        return statusList.filter(item => {
            if (item.machineName.toLowerCase().includes(lowerSearchTerm)) return true;
            if (item.isIdle) return false; 
            
            return (
                item.task.moldName.toLowerCase().includes(lowerSearchTerm) ||
                item.task.taskName.toLowerCase().includes(lowerSearchTerm) || // Ana parça adında ara
                item.task.type.toLowerCase().includes(lowerSearchTerm) || // Operasyon tipinde ara
                item.task.assignedOperator.toLowerCase().includes(lowerSearchTerm) ||
                (item.task.machineOperatorName && item.task.machineOperatorName.toLowerCase().includes(lowerSearchTerm))
            );
        });

    }, [allRunningOperations, machines, searchTerm]);

    // YENİ LİSTE 2: ONAY BEKLEYEN İŞLER (GÜNCELLENDİ)
    const waitingReviewTasks = useMemo(() => {
        const allWaitingTasks = projects.flatMap(mold => 
            mold.tasks.flatMap(task => 
                task.operations
                    .filter(op => op.status === OPERATION_STATUS.WAITING_SUPERVISOR_REVIEW)
                    .map(op => ({
                        ...op,
                        moldName: mold.moldName,
                        moldCustomer: mold.customer,
                        taskName: task.taskName, // Ana parçanın adını ekle
                        moldId: mold.id,
                        taskId: task.id,
                    }))
            )
        );
        
        if (!searchTerm.trim()) return allWaitingTasks;

        return allWaitingTasks.filter(task => // 'task' burada 'operation' objesi
            task.moldName.toLowerCase().includes(lowerSearchTerm) ||
            task.taskName.toLowerCase().includes(lowerSearchTerm) || // Ana parça adında ara
            task.type.toLowerCase().includes(lowerSearchTerm) || // Operasyon tipinde ara
            task.assignedOperator.toLowerCase().includes(lowerSearchTerm) ||
            task.machineName.toLowerCase().includes(lowerSearchTerm) ||
            (task.machineOperatorName && task.machineOperatorName.toLowerCase().includes(lowerSearchTerm))
        );
    }, [projects, searchTerm]);

    // YENİ: Admin/Yetkili için İş Dağılımı Paneli
    const canViewWorkDistribution = loggedInUser.role === ROLES.ADMIN || loggedInUser.role === ROLES.SUPERVISOR;

    const workDistribution = useMemo(() => {
        if (!canViewWorkDistribution) return [];

        // 1. Tüm CAM Operatörlerini personel listesinden al ve sayaçlarını sıfırla
        const camOperators = personnel.filter(p => p.role === PERSONNEL_ROLES.CAM_OPERATOR);
        const workCounts = new Map();
        camOperators.forEach(op => {
            workCounts.set(op.name, 0);
        });

        // 2. 'allRunningOperations' (zaten hesaplanmıştı) kullanarak sayaçları artır
        allRunningOperations.forEach(op => {
            const operatorName = op.assignedOperator;
            if (workCounts.has(operatorName)) {
                workCounts.set(operatorName, workCounts.get(operatorName) + 1);
            }
            // Not: Personel listesinde olmayan (belki silinmiş) bir operatörün işi varsa,
            // bu listede görünmez, çünkü sadece mevcut personel listesini baz alıyoruz.
        });

        // 3. Listeyi objeye çevir ve sırala (en az işi olan en üstte)
        const distributionList = Array.from(workCounts.entries()).map(([name, count]) => ({ name, count }));
        distributionList.sort((a, b) => a.count - b.count);
        
        return distributionList;

    }, [projects, personnel, canViewWorkDistribution, allRunningOperations]);


    const totalActiveCount = machineStatusList.filter(m => !m.isIdle).length + waitingReviewTasks.length;

    return (
        <div className="p-4 bg-white dark:bg-gray-800 rounded-xl shadow-xl space-y-8">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4 md:mb-0">
                    Aktif İş Akışı ({totalActiveCount})
                </h2>
                
                <div className="w-full md:w-64">
                    <input
                        type="text"
                        placeholder="Kalıp, parça, operatör veya tezgah ara..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                </div>
            </div>

            {/* BÖLÜM 1: TEZGAH DURUMLARI */}
            <div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                    Tezgah Durumları ({machineStatusList.filter(m => !m.isIdle).length} / {machineStatusList.length})
                </h3>
                {machineStatusList.length === 0 ? (
                    <div className="text-center py-8">
                        <Cpu className="w-16 h-16 text-gray-400 dark:text-gray-600 mx-auto mb-4" />
                        <p className="text-gray-500 dark:text-gray-400">
                            Sistemde kayıtlı tezgah bulunamadı. Lütfen Admin Panelinden tezgah ekleyin.
                        </p>
                    </div>
                ) : (
                    <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                            <thead className="bg-gray-50 dark:bg-gray-700">
                                <tr>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-gray-300">
                                        Tezgah
                                    </th>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-gray-300">
                                        Durum
                                    </th>
                                    {/* GÜNCELLEME: Sütun adı */}
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-gray-300">
                                        Kalıp / Parça / Operasyon
                                    </th>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-gray-300">
                                        % Durum
                                    </th>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-gray-300">
                                        CAM Operatörü
                                    </th>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-gray-300">
                                        Tezgah Operatörü
                                    </th>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-gray-300">
                                        Başlangıç
                                    </th>
                                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-gray-300">
                                        Geçen Süre
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700">
                                {machineStatusList.map((item) => (
                                    <tr 
                                        key={item.machineName} 
                                        className={item.isIdle ? 'bg-red-50 dark:bg-red-900/10' : 'hover:bg-gray-50 dark:hover:bg-gray-700/50 transition'}
                                    >
                                        <td className="px-4 py-4 whitespace-nowrap">
                                            <div className={`text-sm font-semibold ${item.isIdle ? 'text-red-700 dark:text-red-400' : 'text-gray-900 dark:text-white'}`}>
                                                {item.machineName}
                                            </div>
                                        </td>
                                        <td className="px-4 py-4 whitespace-nowrap">
                                            {item.isIdle ? (
                                                <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300">
                                                    BOŞTA
                                                </span>
                                            ) : (
                                                <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300">
                                                    ÇALIŞIYOR
                                                </span>
                                            )}
                                        </td>
                                        
                                        {/* GÜNCELLEME: Görev Detayları */}
                                        <td className="px-4 py-4 whitespace-nowrap">
                                            {item.task ? (
                                                <>
                                                    <div className="text-sm font-semibold text-gray-900 dark:text-white">
                                                        {item.task.moldName}
                                                    </div>
                                                    <div className="text-sm text-gray-600 dark:text-gray-400">
                                                        {item.task.taskName}
                                                    </div>
                                                    <div className="text-xs font-bold text-blue-600 dark:text-blue-400">
                                                        {item.task.type}
                                                    </div>
                                                </>
                                            ) : (
                                                <span className="text-gray-400 dark:text-gray-600">---</span>
                                            )}
                                        </td>
                                        
                                        <td className="px-4 py-4 whitespace-nowrap">
                                            {item.task ? (
                                                <div className="text-sm font-semibold text-blue-600 dark:text-blue-400">
                                                    %{item.task.progressPercentage}
                                                </div>
                                            ) : (
                                                <span className="text-gray-400 dark:text-gray-600">---</span>
                                            )}
                                        </td>

                                        <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-300">
                                            {item.task ? item.task.assignedOperator : '---'}
                                        </td>
                                        <td className="px-4 py-4 whitespace-nowrap text-xs text-gray-500 dark:text-gray-400">
                                            {item.task ? item.task.machineOperatorName : '---'}
                                        </td>
                                        <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">
                                            {item.task ? formatDate(item.task.startDate) : '---'}
                                        </td>
                                        <td className="px-4 py-4 whitespace-nowrap">
                                            {item.task ? (
                                                <div className="text-sm font-semibold text-blue-600 dark:text-blue-400">
                                                    {formatDuration(item.task.startDate)}
                                                </div>
                                            ) : (
                                                <span className="text-gray-400 dark:text-gray-600">---</span>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* YENİ BÖLÜM: İŞ DAĞILIMI (SADECE ADMİN VE YETKİLİ) */}
            {canViewWorkDistribution && (
                <div>
                    <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                        <Users className="w-6 h-6 inline-block mr-2" />
                        CAM Operatörü İş Dağılımı
                    </h3>
                    <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
                        Operatörlerin mevcut "ÇALIŞIYOR" durumundaki operasyon sayıları. En az işi olan operatörler en üsttedir.
                    </p>
                    
                    {workDistribution.length === 0 ? (
                        <div className="text-center py-8 text-gray-500 dark:text-gray-400">
                            Sistemde kayıtlı CAM Operatörü bulunamadı.
                        </div>
                    ) : (
                        <div className="overflow-x-auto max-w-lg border border-gray-200 dark:border-gray-700 rounded-lg">
                            <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                                <thead className="bg-gray-50 dark:bg-gray-700">
                                    <tr>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-gray-300">
                                            CAM Operatörü
                                        </th>
                                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-gray-300">
                                            Aktif Görev Sayısı
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700">
                                    {workDistribution.map((item) => (
                                        <tr 
                                            key={item.name} 
                                            className={
                                                item.count === 0 
                                                ? 'bg-green-50 dark:bg-green-900/10' 
                                                : 'hover:bg-gray-50 dark:hover:bg-gray-700/50 transition'
                                            }
                                        >
                                            <td className="px-4 py-4 whitespace-nowrap">
                                                <div className={`text-sm font-semibold ${item.count === 0 ? 'text-green-700 dark:text-green-400' : 'text-gray-900 dark:text-white'}`}>
                                                    {item.name}
                                                </div>
                                            </td>
                                            <td className="px-4 py-4 whitespace-nowrap">
                                                <span className={`inline-flex px-3 py-1 text-sm font-bold rounded-full ${
                                                    item.count === 0 
                                                    ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300' 
                                                    : (item.count <= 2 ? 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300' : 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300')
                                                }`}>
                                                    {item.count}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            )}
            {/* YENİ BÖLÜM SONU */}

        </div>
    );
};

// --- GÜNCELLENMİŞ: GELİŞMİŞ KALIP LİSTESİ ---
const EnhancedMoldList = ({ projects, onSelectMold }) => {
    // ... (Mevcut fonksiyon - filtreleme ve istatistikler aynı kaldı)
    const [activeFilter, setActiveFilter] = useState('all');
    const [searchTerm, setSearchTerm] = useState('');
    
    // GÜNCELLEME: Parça ilerlemesini hesaplar
    // Artık tüm operasyonların ortalamasını alır
    const calculateMoldProgress = (tasks) => {
        if (!tasks || tasks.length === 0) return 0;
        
        const allOperations = tasks.flatMap(t => t.operations);
        if (allOperations.length === 0) return 0;

        const totalProgress = allOperations.reduce((acc, op) => acc + op.progressPercentage, 0);
        return totalProgress / allOperations.length;
    };
    
    const filteredProjects = useMemo(() => {
        // ... (Mevcut filtreleme mantığı - değişiklik yok)
        let filtered = projects;
        if (activeFilter !== 'all') {
            if (activeFilter === 'ACTIVE_OVERVIEW') { 
                filtered = filtered.filter(project => 
                    MOLD_STATUS_ACTIVE_LIST.includes(project.status)
                );
            } else {
                filtered = filtered.filter(project => 
                    project.status === activeFilter
                );
            }
        }
        if (searchTerm.trim()) {
            const lowerSearchTerm = searchTerm.toLowerCase();
            filtered = filtered.filter(project => 
                project.moldName.toLowerCase().includes(lowerSearchTerm) ||
                project.customer.toLowerCase().includes(lowerSearchTerm)
            );
        }
        return filtered;
    }, [projects, activeFilter, searchTerm]);

    const stats = useMemo(() => {
        // ... (Mevcut istatistik mantığı - değişiklik yok)
        const counts = {
            total: projects.length,
            waiting: 0,
            completed: 0,
            activeOverview: 0,
        };
        Object.values(MOLD_STATUS).forEach(status => {
            counts[status] = 0;
        });
        for (const project of projects) {
            const status = project.status || MOLD_STATUS.WAITING;
            if (counts[status] !== undefined) {
                counts[status]++;
            }
            if (MOLD_STATUS_ACTIVE_LIST.includes(status)) {
                counts.activeOverview++;
            }
        }
        counts.waiting = counts[MOLD_STATUS.WAITING];
        counts.completed = counts[MOLD_STATUS.COMPLETED];
        return counts;
    }, [projects]);

    const FilterCard = ({ filterKey, title, count, icon: Icon, colorClass }) => {
        // ... (Mevcut bileşen - değişiklik yok)
        const isActive = activeFilter === filterKey;
        return (
            <div 
                className={`p-3 rounded-lg border-2 cursor-pointer transition-all ${
                    isActive 
                        ? `${colorClass} dark:bg-opacity-20` 
                        : 'border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600'
                }`}
                onClick={() => setActiveFilter(filterKey)}
            >
                <div className="flex items-center justify-between">
                    <div>
                        <p className="text-sm font-medium text-gray-600 dark:text-gray-400">{title}</p>
                        <p className="text-2xl font-bold text-gray-900 dark:text-white">{count}</p>
                    </div>
                    {Icon && <Icon className={`w-8 h-8 ${isActive ? '' : 'text-gray-400'}`} />}
                </div>
            </div>
        );
    };

    return (
        <div className="p-4 bg-white dark:bg-gray-800 rounded-xl shadow-xl">
            {/* Filtreleme Kutucukları */}
            <div className="flex flex-wrap gap-4 mb-6">
                <FilterCard 
                    filterKey="all" 
                    title="Tüm Kalıplar" 
                    count={stats.total} 
                    icon={Filter}
                    colorClass="border-blue-500 bg-blue-50"
                />
                <FilterCard 
                    filterKey="ACTIVE_OVERVIEW"
                    title="Aktif Çalışan" 
                    count={stats.activeOverview} 
                    icon={PlayCircle}
                    colorClass="border-green-500 bg-green-50 text-green-500"
                />
                <FilterCard 
                    filterKey={MOLD_STATUS.WAITING}
                    title="Beklemede" 
                    count={stats.waiting} 
                    icon={RefreshCw}
                    colorClass="border-yellow-500 bg-yellow-50 text-yellow-500"
                />
                <FilterCard 
                    filterKey={MOLD_STATUS.CNC}
                    title="CNC" 
                    count={stats[MOLD_STATUS.CNC]} 
                    icon={Cpu}
                    colorClass="border-blue-500 bg-blue-50 text-blue-500"
                />
                <FilterCard 
                    filterKey={MOLD_STATUS.EREZYON}
                    title="Erezyon" 
                    count={stats[MOLD_STATUS.EREZYON]} 
                    icon={Zap}
                    colorClass="border-blue-500 bg-blue-50 text-blue-500"
                />
                <FilterCard 
                    filterKey={MOLD_STATUS.POLISAJ}
                    title="Polisaj" 
                    count={stats[MOLD_STATUS.POLISAJ]} 
                    icon={Sparkles}
                    colorClass="border-blue-500 bg-blue-50 text-blue-500"
                />
                 <FilterCard 
                    filterKey={MOLD_STATUS.DESEN}
                    title="Desen" 
                    count={stats[MOLD_STATUS.DESEN]} 
                    icon={Edit2}
                    colorClass="border-blue-500 bg-blue-50 text-blue-500"
                />
                 <FilterCard 
                    filterKey={MOLD_STATUS.MOLD_ASSEMBLY}
                    title="Kalıp Montaj" 
                    count={stats[MOLD_STATUS.MOLD_ASSEMBLY]} 
                    icon={HardHat}
                    colorClass="border-blue-500 bg-blue-50 text-blue-500"
                />
                 <FilterCard 
                    filterKey={MOLD_STATUS.TRIAL}
                    title="Deneme'de" 
                    count={stats[MOLD_STATUS.TRIAL]} 
                    icon={Settings}
                    colorClass="border-blue-500 bg-blue-50 text-blue-500"
                />
                <FilterCard 
                    filterKey={MOLD_STATUS.REVISION}
                    title="Revizyon" 
                    count={stats[MOLD_STATUS.REVISION]} 
                    icon={Settings}
                    colorClass="border-blue-500 bg-blue-50 text-blue-500"
                />
                <FilterCard 
                    filterKey={MOLD_STATUS.COMPLETED}
                    title="Tamamlanan" 
                    count={stats.completed} 
                    icon={CheckCircle}
                    colorClass="border-green-500 bg-green-50 text-green-500"
                />
            </div>

            {/* Arama Çubuğu */}
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6">
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4 md:mb-0">
                    Kalıp Listesi
                    <span className="text-sm font-normal text-gray-500 dark:text-gray-400 ml-2">
                        ({filteredProjects.length} kalıp)
                    </span>
                </h2>
                
                <div className="w-full md:w-64 relative">
                    <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
                    <input
                        type="text"
                        placeholder="Kalıp no veya firma ara..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                </div>
            </div>

            {/* Kalıp Listesi */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
                {filteredProjects.length === 0 ? (
                    <div className="col-span-full text-center py-8">
                        <List className="w-16 h-16 text-gray-400 dark:text-gray-600 mx-auto mb-4" />
                        <p className="text-gray-500 dark:text-gray-400">
                            Arama kriterlerinize uygun kalıp bulunamadı.
                        </p>
                    </div>
                ) : (
                    filteredProjects.map(project => {
                        const totalProgress = calculateMoldProgress(project.tasks);
                        const moldStatus = project.status || MOLD_STATUS.WAITING;
                        
                        // YENİ: CAM Operatörlerini Bulma (Tüm operasyonlardan)
                        const assignedCamOperators = project.tasks
                            .flatMap(task => task.operations.map(op => op.assignedOperator))
                            .filter(op => op && op !== 'SEÇ');
                        const uniqueCamOperators = [...new Set(assignedCamOperators)];
                        
                        // Kritik durum uyarısı
                        const remainingDays = calculateRemainingWorkDays(project.moldDeadline);
                        const isCritical = remainingDays !== null && 
                                         remainingDays <= 6 &&
                                         remainingDays >= 0 &&
                                         totalProgress <= 80 &&
                                         moldStatus !== MOLD_STATUS.COMPLETED;
                                         
                        const cardHighlightClasses = isCritical 
                            ? 'bg-red-100 dark:bg-red-900/30 border-red-600 dark:border-red-500 animate-pulse'
                            : 'bg-white dark:bg-gray-800 border-blue-500 dark:border-blue-600';
                            
                        const progressBarClass = moldStatus === MOLD_STATUS.COMPLETED 
                            ? 'bg-green-600'
                            : 'bg-blue-600';
                            
                        // --- YENİ: PARÇA DURUM SAYAÇLARI ---
                        const activeOperationCounts = {};
                        let workingPartCount = 0;
                        let idlePartCount = 0;

                        project.tasks.forEach(task => {
                            const operations = task.operations || [];
                            
                            const inProgressOps = operations.filter(op => op.status === OPERATION_STATUS.IN_PROGRESS);
                            const notStartedOps = operations.filter(op => op.status === OPERATION_STATUS.NOT_STARTED);

                            // 1. Çalışan Parça Sayacı
                            if (inProgressOps.length > 0) {
                                workingPartCount++;
                            }

                            // 2. Boşta Parça Sayacı
                            if (operations.length > 0 && notStartedOps.length === operations.length) {
                                idlePartCount++;
                            }

                            // 3. Aktif Operasyon Tipleri Sayacı
                            inProgressOps.forEach(op => {
                                activeOperationCounts[op.type] = (activeOperationCounts[op.type] || 0) + 1;
                            });
                        });

                        const activeOperationEntries = Object.entries(activeOperationCounts);
                        // --- SAYAÇ SONU ---

                        return (
                            <div
                                key={project.id}
                                onClick={() => onSelectMold(project)}
                                className={`p-4 rounded-xl shadow-lg hover:shadow-xl transition duration-300 transform hover:-translate-y-1 cursor-pointer border-t-4 flex flex-col ${cardHighlightClasses}`}
                            >
                                <div className="flex-grow">
                                    <div className="flex justify-between items-start mb-3">
                                        <h3 className="text-lg font-bold text-gray-900 dark:text-white">{project.moldName}</h3>
                                        <span className={`px-2 py-0.5 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusClasses(moldStatus)}`}>
                                            {moldStatus}
                                        </span>
                                    </div>
                                    <p className="text-gray-600 dark:text-gray-400 text-xs mb-1">
                                        Müşteri: <span className="font-semibold">{project.customer}</span>
                                    </p>
                                    
                                    <p className="text-gray-600 dark:text-gray-400 text-xs">
                                        Termin: <span className="font-semibold">{formatDate(project.moldDeadline) || '---'}</span>
                                    </p>
                                    
                                    {/* Termin Mantığı */}
                                    {moldStatus === MOLD_STATUS.COMPLETED ? (
                                        (() => {
                                            let latestCompletion = null;
                                            try {
                                                // GÜNCELLEME: Tüm operasyonların tamamlanma tarihine bak
                                                const reviewDates = project.tasks
                                                    .flatMap(t => t.operations)
                                                    .filter(op => op.status === OPERATION_STATUS.COMPLETED && op.supervisorReviewDate)
                                                    .map(op => new Date(op.supervisorReviewDate).getTime());

                                                if (reviewDates.length > 0) {
                                                    const maxDate = Math.max(...reviewDates);
                                                    latestCompletion = new Date(maxDate).toISOString();
                                                }
                                            } catch (e) {
                                                console.error("Tamamlanma tarihi ayrıştırılamadı", e, project.tasks);
                                            }

                                            let completionText = latestCompletion 
                                                ? `Tamamlandı: ${formatDate(latestCompletion)}` 
                                                : 'Tamamlandı (Tarih Yok)';
                                            
                                            const diff = calculateWorkDayDifference(latestCompletion, project.moldDeadline);
                                            
                                            let diffText = '';
                                            if (diff !== null) {
                                                if (diff > 0) {
                                                    diffText = `<span class="text-green-700 dark:text-green-500 font-semibold"> (${diff} iş günü erken)</span>`;
                                                } else if (diff < 0) {
                                                    diffText = `<span class="text-red-700 dark:text-red-500 font-semibold"> (${Math.abs(diff)} iş günü geç)</span>`;
                                                } else if (diff === 0) {
                                                    diffText = `<span class="text-gray-600 dark:text-gray-400 font-semibold"> (Tam zamanında)</span>`;
                                                }
                                            }
                                                
                                            return (
                                                <p 
                                                    className="text-xs mt-1 text-green-700 dark:text-green-500 font-semibold"
                                                    dangerouslySetInnerHTML={{ __html: completionText + diffText }}
                                                >
                                                </p>
                                            );
                                        })()
                                    ) : (
                                        (() => {
                                            let remainingDaysText = 'Termin Belirsiz';
                                            let remainingDaysColor = 'text-gray-500 dark:text-gray-400';
                                            if (remainingDays !== null) {
                                                if (remainingDays > 5) {
                                                    remainingDaysText = `${remainingDays} iş günü kaldı`;
                                                    remainingDaysColor = 'text-green-600 dark:text-green-400';
                                                } else if (remainingDays > 0) {
                                                    remainingDaysText = `${remainingDays} iş günü kaldı (KRİTİK)`;
                                                    remainingDaysColor = 'text-yellow-600 dark:text-yellow-400 font-semibold';
                                                } else if (remainingDays === 0) {
                                                    remainingDaysText = 'SON GÜN';
                                                    remainingDaysColor = 'text-red-600 dark:text-red-400 font-bold animate-pulse';
                                                } else {
                                                    remainingDaysText = `TERMİN ${Math.abs(remainingDays)} GÜN GEÇTİ`;
                                                    remainingDaysColor = 'text-red-700 dark:text-red-500 font-bold';
                                                }
                                            }
                                            return (
                                                <p className={`text-xs mt-1 ${remainingDaysColor}`}>
                                                    {remainingDaysText}
                                                </p>
                                            );
                                        })()
                                    )}

                                    <p className="text-gray-600 dark:text-gray-400 text-xs mt-2">
                                        Alt Parça Sayısı: <span className="font-semibold">{project.tasks.length}</span>
                                    </p>
                                    
                                    {/* YENİ: Sayaçları Göster */}
                                    <div className="text-xs mt-1 space-y-0.5">
                                        <p className="text-blue-600 dark:text-blue-400">
                                            <PlayCircle className="w-3 h-3 inline-block mr-1" />
                                            Çalışan Parça: <span className="font-semibold">{workingPartCount}</span>
                                        </p>
                                        
                                        {/* Aktif Operasyon Dökümü */}
                                        {activeOperationEntries.length > 0 && (
                                            <div className="pl-4">
                                                {activeOperationEntries.map(([type, count]) => (
                                                    <p key={type} className="text-gray-700 dark:text-gray-300">
                                                        <Cpu className="w-3 h-3 inline-block mr-1" />
                                                        {type}: <span className="font-semibold">{count}</span>
                                                    </p>
                                                ))}
                                            </div>
                                        )}

                                        <p className="text-red-600 dark:text-red-400">
                                            <RefreshCw className="w-3 h-3 inline-block mr-1" />
                                            Boşta Parça: <span className="font-semibold">{idlePartCount}</span>
                                        </p>
                                    </div>
                                    {/* GÖSTERİM SONU */}

                                    {uniqueCamOperators.length > 0 && (
                                        <div className="mt-2 pt-2 border-t border-gray-200 dark:border-gray-700">
                                            <p className="text-xs text-gray-500 dark:text-gray-400 font-medium mb-1">
                                                Sorumlu CAM Operatörleri:
                                            </p>
                                            <ul className="space-y-0.5">
                                                {uniqueCamOperators.map(operator => (
                                                    <li key={operator} className="text-xs text-gray-800 dark:text-gray-300 font-semibold truncate">
                                                        - {operator}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                                
                                <div className="mt-3">
                                    <div className="flex justify-between text-xs text-gray-600 dark:text-gray-400 mb-1">
                                        {/* GÜNCELLEME: Etiket */}
                                        <span>Toplam Operasyon İlerlemesi</span>
                                        <span>%{totalProgress.toFixed(0)}</span>
                                    </div>
                                    <div className="w-full bg-gray-200 rounded-full h-2 dark:bg-gray-700">
                                        <div 
                                            className={`${progressBarClass} h-2 rounded-full`} 
                                            style={{ width: `${totalProgress.toFixed(0)}%` }}>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    );
};
// GÜNCELLEME SONU

// --- MEVCUT BİLEŞENLER (GÜNCELLENMİŞ) ---

// GÜNCELLEME: Artık 'AssignOperationModal'
const AssignOperationModal = ({ isOpen, onClose, mold, task, operation, loggedInUser, onSubmit, projects, personnel, machines }) => {
    const [machine, setMachine] = useState('');
    const [operator, setOperator] = useState('');
    const [dueDate, setDueDate] = useState('');
    const [machineError, setMachineError] = useState('');
    const today = new Date().toISOString().split('T')[0];

    // ... (useMemo - camOperators, machineOperators, availableMachines - değişiklik yok)
    const machineOperators = useMemo(() => 
        personnel.filter(p => p.role === PERSONNEL_ROLES.MACHINE_OPERATOR).map(p => p.name),
        [personnel]
    );
    const availableMachines = useMemo(() => 
        machines.map(m => m.name),
        [machines]
    );

    useEffect(() => {
        if (isOpen) {
            setDueDate(new Date(Date.now() + 3 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]);
            setMachineError('');
            if (availableMachines.length > 0 && !machine) {
                setMachine(availableMachines[0] || '');
            }
            if (machineOperators.length > 0 && !operator) {
                setOperator(machineOperators[0] || '');
            }
        }
    }, [isOpen, availableMachines, machineOperators, machine, operator]);

    // GÜNCELLEME: Tezgah kontrolü artık operasyonları kontrol ediyor
    const checkMachineAvailability = useCallback((machineName) => {
        const isMachineBusy = projects.some(project => 
            project.tasks.some(t => 
                t.operations.some(op => 
                    op.machineName === machineName && 
                    op.status === OPERATION_STATUS.IN_PROGRESS &&
                    op.id !== operation?.id // Mevcut operasyonu hariç tut
                )
            )
        );
        return !isMachineBusy;
    }, [projects, operation]);

    const handleMachineChange = (selectedMachine) => {
        setMachine(selectedMachine);
        if (!checkMachineAvailability(selectedMachine)) {
            setMachineError(`⚠️ ${selectedMachine} tezgahı şu anda başka bir işte kullanılıyor!`);
        } else {
            setMachineError('');
        }
    };

    const handleSave = () => {
        if (!machine || !operator || !dueDate) {
            console.error("Tüm alanlar doldurulmalıdır.");
            return;
        }
        if (!checkMachineAvailability(machine)) {
            setMachineError(`⚠️ ${machine} tezgahı başka bir işte kullanılıyor! Lütfen başka bir tezgah seçin.`);
            return;
        }

        const updatedOperation = {
            ...operation,
            assignedOperator: loggedInUser.name,
            machineName: machine,
            machineOperatorName: operator,
            estimatedDueDate: dueDate,
            startDate: getCurrentDateTimeString(),
            status: OPERATION_STATUS.IN_PROGRESS,
            progressPercentage: 0,
        };
        // GÜNCELLEME: Yeni onSubmit imzası
        onSubmit(mold.id, task.id, updatedOperation);
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={`Operasyon Atama: ${task.taskName} (${operation.type})`}>
            <p className="text-gray-700 dark:text-gray-300 mb-4">Bu operasyonu kendinize atayarak ({loggedInUser.name}) gerekli tezgah ve operatör bilgilerini giriniz.</p>

            <div className="space-y-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Tezgah Seçimi</label>
                    <select
                        value={machine}
                        onChange={(e) => handleMachineChange(e.target.value)}
                        className="mt-1 block w-full rounded-lg border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                    >
                        <option value="">Tezgah Seçiniz</option>
                        {availableMachines.map(m => <option key={m} value={m}>{m}</option>)}
                    </select>
                    {machineError && (
                        <div className="mt-2 flex items-center text-sm text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-900/20 p-2 rounded-lg">
                            <AlertTriangle className="w-4 h-4 mr-2" />
                            {machineError}
                        </div>
                    )}
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Tezgah Operatörü (Sadece Gözükecek)</label>
                    <select
                        value={operator}
                        onChange={(e) => setOperator(e.target.value)}
                        className="mt-1 block w-full rounded-lg border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                    >
                        <option value="">Operatör Seçiniz</option>
                        {machineOperators.map(op => <option key={op} value={op}>{op}</option>)}
                    </select>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Tahmini Termin Süresi (Tarih)</label>

                    {mold && mold.moldDeadline && (
                        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 mb-1">
                            (Ana Kalıp Termini: {formatDate(mold.moldDeadline)})
                        </p>
                    )}
                    
                    <input
                        type="date"
                        value={dueDate}
                        min={today}
                        onChange={(e) => setDueDate(e.target.value)}
                        className="block w-full rounded-lg border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                    />
                </div>
            </div>

            <div className="mt-6 flex justify-end space-x-3">
                <button
                    onClick={onClose}
                    className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-200 dark:bg-gray-700 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition"
                >
                    İptal
                </button>
                <button
                    onClick={handleSave}
                    disabled={!!machineError || !machine || !operator}
                    className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition flex items-center disabled:bg-blue-400 disabled:cursor-not-allowed"
                >
                    <Send className="w-4 h-4 mr-2"/> İşi Ata ve Başlat
                </button>
            </div>
        </Modal>
    );
};

// GÜNCELLEME: Artık 'operation' alıyor
const ProgressUpdateModal = ({ isOpen, onClose, mold, task, operation, onSubmit, onNeedsMachineOpReview }) => {
    const [progress, setProgress] = useState(operation.progressPercentage);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setProgress(operation.progressPercentage);
        }
    }, [isOpen, operation.progressPercentage]);

    const handleSave = async () => {
        setIsSaving(true);
        
        if (progress === 100) {
            // GÜNCELLEME: 'operation' objesini gönder
            onNeedsMachineOpReview({ ...operation, progressPercentage: 100 });
            setIsSaving(false);
            // onClose(); // HATA BURADAYDI! Bu satır kaldırıldı.
        } else {
            let updatedOperation = { ...operation, progressPercentage: progress };
            // GÜNCELLEME: Yeni onSubmit imzası
            await onSubmit(mold.id, task.id, updatedOperation);
            setIsSaving(false);
            onClose();
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={`İlerleme Güncelle: ${task.taskName} (${operation.type})`}>
            <p className="text-gray-700 dark:text-gray-300 mb-4">Mevcut ilerleme yüzdesini giriniz (0-100).</p>

            <div className="space-y-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">İlerleme Yüzdesi: %{progress}</label>
                    <input
                        type="range"
                        min="0"
                        max="100"
                        step="1"
                        value={progress}
                        onChange={(e) => setProgress(parseInt(e.target.value))}
                        className="mt-1 block w-full h-2 bg-blue-100 rounded-lg appearance-none cursor-pointer dark:bg-blue-700"
                    />
                </div>
                
                {progress === 100 && (
                    <div className="p-3 bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-700 rounded-lg text-sm text-green-700 dark:text-green-300">
                        Kaydettiğinizde, **'TEZGAH OPERATÖRÜNÜ DEĞERLENDİR'** ekranı açılacaktır.
                    </div>
                )}
            </div>

            <div className="mt-6 flex justify-end space-x-3">
                <button
                    onClick={onClose}
                    className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-200 dark:bg-gray-700 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition"
                >
                    İptal
                </button>
                <button
                    onClick={handleSave}
                    disabled={isSaving}
                    className="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-lg hover:bg-green-700 transition flex items-center disabled:bg-green-400"
                >
                    {isSaving ? 'Kaydediliyor...' : <><CheckCircle className="w-4 h-4 mr-2"/> Kaydet</>}
                </button>
            </div>
        </Modal>
    );
};

// GÜNCELLEME: Artık 'operation' alıyor
const CamReviewMachineOpModal = ({ isOpen, onClose, mold, task, operation, onSubmit }) => {
    const [rating, setRating] = useState(10);
    const [comment, setComment] = useState('');
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if(isOpen) {
            setRating(10);
            setComment('');
        }
    }, [isOpen]);

    const handleSave = async () => {
        if (!operation || !task || !mold) return;

        setIsSaving(true);
        const finishDate = getCurrentDateTimeString();
        const durationInHours = calculateDurationInHours(operation.startDate, finishDate);

        const updatedOperation = {
            ...operation,
            progressPercentage: 100,
            finishDate: finishDate,
            durationInHours: durationInHours,
            camOperatorRatingForMachineOp: rating,
            camOperatorCommentForMachineOp: comment,
            camOperatorReviewDate: getCurrentDateTimeString(),
            status: OPERATION_STATUS.WAITING_SUPERVISOR_REVIEW,
        };
        
        // GÜNCELLEME: Yeni onSubmit imzası
        await onSubmit(mold.id, task.id, updatedOperation);
        setIsSaving(false);
        onClose();
    };

    if (!operation || !task) return null;

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={`Tezgah Operatörü Değerlendirmesi: ${task.taskName} (${operation.type})`}>
            <p className="text-gray-700 dark:text-gray-300 mb-4">İşi %100 olarak tamamladınız. Lütfen bu iş için atanan tezgah operatörünün performansını değerlendirin.</p>

            <div className="space-y-4 p-4 bg-gray-50 dark:bg-gray-700/50 rounded-lg">
                <p className="font-semibold dark:text-white">Değerlendirilen Tezgah Operatörü: <span className="font-normal">{operation.machineOperatorName}</span></p>
                <p className="font-semibold dark:text-white">Tezgah: <span className="font-normal">{operation.machineName}</span></p>
            </div>

            <div className="space-y-4 mt-4">
                 <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Tezgah Operatörü Puanı: {rating} / 10</label>
                    <input
                        type="range"
                        min="1"
                        max="10"
                        step="1"
                        value={rating}
                        onChange={(e) => setRating(parseInt(e.target.value))}
                        className="mt-1 block w-full h-2 bg-blue-100 rounded-lg appearance-none cursor-pointer dark:bg-blue-700"
                    />
                </div>
                 <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Yorum (Opsiyonel)</label>
                    <textarea
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        rows="3"
                        placeholder="Tezgah operatörü için bir yorum yazın..."
                        className="mt-1 block w-full rounded-lg border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                    ></textarea>
                </div>
            </div>

            <div className="mt-6 flex justify-end space-x-3">
                <button
                    onClick={onClose}
                    className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-200 dark:bg-gray-700 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition"
                >
                    İptal
                </button>
                <button
                    onClick={handleSave}
                    disabled={isSaving}
                    className="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-lg hover:bg-green-700 transition flex items-center disabled:bg-green-400"
                >
                    <UserCheck className="w-4 h-4 mr-2"/> {isSaving ? 'Kaydediliyor...' : 'Değerlendir ve Yetkiliye Gönder'}
                </button>
            </div>
        </Modal>
    );
};

// GÜNCELLEME: Artık 'operation' alıyor
const SupervisorReviewModal = ({ isOpen, onClose, mold, task, operation, onSubmit }) => {
    const [rating, setRating] = useState(10);
    const [comment, setComment] = useState('');
    const [isSaving, setIsSaving] = useState(false);
    // KALDIRILDI: const [isGeminiLoading, setIsGeminiLoading] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setRating(10);
            setComment('');
        }
    }, [isOpen]);

    // KALDIRILDI: handleSuggestComment fonksiyonu
    /*
    const handleSuggestComment = async () => {
        setIsGeminiLoading(true);
        const systemPrompt = "Sen bir kalıphane yetkilisisin (Fabrika Yöneticisi). Bir CAM operatörünün tamamladığı işi değerlendiriyorsun. Puanına ve süresine göre, operatöre Türkçe, kısa (1-2 cümle) ve yapıcı bir geri bildirim yorumu yaz.";
        // GÜNCELLEME: operation objesinden veri al
        const userQuery = `Operatör: ${operation.assignedOperator}, İş: ${task.taskName} (${operation.type}), Süre: ${operation.durationInHours} saat, Puanım (1-10): ${rating}. Lütfen geri bildirim yorumunu oluştur.`;

        try {
            const suggestedComment = await callGeminiApi(userQuery, systemPrompt);
            setComment(suggestedComment.replace(/"/g, ''));
        } catch (error) {
            console.error("Gemini yorum önerisi hatası:", error);
            setComment("Yorum oluşturulurken bir hata oluştu.");
        }
        setIsGeminiLoading(false);
    };
    */

    const handleSave = async () => {
        setIsSaving(true);
        const updatedOperation = {
            ...operation,
            supervisorRating: rating,
            supervisorReviewDate: getCurrentDateTimeString(),
            status: OPERATION_STATUS.COMPLETED,
            supervisorComment: comment,
        };
        
        // GÜNCELLEME: Yeni onSubmit imzası
        await onSubmit(mold.id, task.id, updatedOperation);
        setIsSaving(false);
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={`İş Değerlendirme: ${task.taskName} (${operation.type})`}>
            <p className="text-gray-700 dark:text-gray-300 mb-4">Bu iş parçasının kalıphaneye uygunluğunu 1-10 arası puanlayarak onaylayınız.</p>

            {/* GÜNCELLEME: operation objesinden veri al */}
            <div className="space-y-4">
                <p className="font-semibold dark:text-white">CAM Operatörü: {operation.assignedOperator}</p>
                <p className="text-sm text-gray-500 dark:text-gray-400">İş Süresi: {operation.durationInHours} Saat (Başlangıç: {formatDateTime(operation.startDate)} - Bitiş: {formatDateTime(operation.finishDate)})</p>
                <p className="text-sm text-gray-500 dark:text-gray-400">CAM'in Tezgah Op. Onay Tarihi: {formatDateTime(operation.camOperatorReviewDate)}</p>
                <p className="text-sm text-gray-500 dark:text-gray-400">CAM'in Tezgah Op. Puanı: <span className="font-semibold">{operation.camOperatorRatingForMachineOp || 'N/A'} / 10</span></p>

                <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Değerlendirme Puanı (CAM için): {rating} / 10</label>
                    <input
                        type="range"
                        min="1"
                        max="10"
                        step="1"
                        value={rating}
                        onChange={(e) => setRating(parseInt(e.target.value))}
                        className="mt-1 block w-full h-2 bg-red-100 rounded-lg appearance-none cursor-pointer dark:bg-red-700"
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Yetkili Yorumu (CAM için Opsiyonel)</label>
                    <textarea
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        rows="3"
                        placeholder="CAM Operatörü için bir geri bildirim yazın..."
                        className="mt-1 block w-full rounded-lg border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                    ></textarea>
                    {/* KALDIRILDI: Yorum Öner Butonu */}
                    {/*
                    <button
                        onClick={handleSuggestComment}
                        disabled={isGeminiLoading}
                        className="mt-2 px-3 py-1 text-sm font-medium text-white bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg hover:from-purple-600 hover:to-pink-600 transition flex items-center shadow-md disabled:opacity-50"
                    >
                        <Sparkles className="w-4 h-4 mr-2"/>
                        {isGeminiLoading ? 'Öneriliyor...' : '✨ Yorum Öner'}
                    </button>
                    */}
                </div>
            </div>

            <div className="mt-6 flex justify-end space-x-3">
                <button
                    onClick={onClose}
                    className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-200 dark:bg-gray-700 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition"
                >
                    İptal
                </button>
                <button
                    onClick={handleSave}
                    disabled={isSaving}
                    className="px-4 py-2 text-sm font-medium text-white bg-purple-600 rounded-lg hover:bg-purple-700 transition flex items-center disabled:bg-purple-400"
                >
                    <CheckCircle className="w-4 h-4 mr-2"/> {isSaving ? 'Onaylanıyor...' : 'Onayla ve Bitir'}
                </button>
            </div>
        </Modal>
    );
};

// --- YENİ: YENİ OPERASYON EKLEME MODALI ---
const AddOperationModal = ({ isOpen, onClose, mold, task, onSubmit }) => {
    const [operationType, setOperationType] = useState(Object.keys(ADDABLE_OPERATION_TYPES)[0]);
    const [isSaving, setIsSaving] = useState(false);
    
    const handleSave = async () => {
        if (!mold || !task || !operationType) return;
        
        setIsSaving(true);
        
        // 1. Yeni operasyon objesini oluştur
        const newOpId = `op-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
        const newOperation = {
            id: newOpId,
            type: ADDABLE_OPERATION_TYPES[operationType], // Değeri al (örn: "AYNA POLİSAJ")
            status: OPERATION_STATUS.NOT_STARTED,
            progressPercentage: 0,
            assignedOperator: 'SEÇ',
            machineName: '',
            machineOperatorName: '',
            estimatedDueDate: '',
            startDate: '',
            finishDate: '',
            durationInHours: null,
            supervisorRating: null,
            supervisorReviewDate: null,
            supervisorComment: null,
            camOperatorRatingForMachineOp: null,
            camOperatorCommentForMachineOp: null,
            camOperatorReviewDate: null
        };
        
        // 2. onSubmit'i çağır (Bu fonksiyon App.js'te tanımlanacak)
        // Bu fonksiyon, projeyi bulup, task'ı bulup, operations dizisine ekleyip, db'yi güncelleyecek.
        try {
            await onSubmit(mold.id, task.id, newOperation);
        } catch (error) {
            console.error("Yeni operasyon eklenirken hata:", error);
        } finally {
            setIsSaving(false);
            onClose();
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={`Yeni Operasyon Ekle: ${task.taskName}`}>
            <p className="text-gray-700 dark:text-gray-300 mb-4">Bu parçaya yeni bir iş operasyonu (Erezyon, Polisaj vb.) ekleyin.</p>
            
            <div className="space-y-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Operasyon Tipi</label>
                    <select
                        value={operationType}
                        onChange={(e) => setOperationType(e.target.value)}
                        className="mt-1 block w-full rounded-lg border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                    >
                        {Object.entries(ADDABLE_OPERATION_TYPES).map(([key, value]) => (
                            <option key={key} value={key}>{value}</option>
                        ))}
                    </select>
                </div>
            </div>

            <div className="mt-6 flex justify-end space-x-3">
                <button
                    onClick={onClose}
                    className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-200 dark:bg-gray-700 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition"
                >
                    İptal
                </button>
                <button
                    onClick={handleSave}
                    disabled={isSaving}
                    className="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-lg hover:bg-green-700 transition flex items-center disabled:bg-green-400"
                >
                    <Plus className="w-4 h-4 mr-2"/> {isSaving ? 'Ekleniyor...' : 'Operasyon Ekle'}
                </button>
            </div>
        </Modal>
    );
};


// --- GÜNCELLENMİŞ: KALIP DETAY SAYFASI ---
const MoldDetailPage = ({ mold, onBack, loggedInUser, handleUpdateOperation, handleAddOperation, projects, personnel, machines, handleUpdateMoldStatus, handleUpdateMoldDeadline, db }) => {
    const [modalState, setModalState] = useState({ isOpen: false, type: null, data: null });
    
    // YENİ: Admin'in termin tarihini değiştirebilmesi için lokal state
    const [localDeadline, setLocalDeadline] = useState(mold.moldDeadline || '');
    
    // YENİ: Notlar için State
    const [isNoteModalOpen, setIsNoteModalOpen] = useState(false);
    const [noteText, setNoteText] = useState('');
    const [newNoteContent, setNewNoteContent] = useState('');
    const [isSaving, setIsSaving] = useState(false);


    // mold prop'u değiştiğinde local state'i güncelle
    useEffect(() => {
        setLocalDeadline(mold.moldDeadline || '');
    }, [mold.moldDeadline]);

    // YENİ: Firestore'dan notu dinle
    useEffect(() => {
        // ... (Mevcut fonksiyon - değişiklik yok)
        if (!db || !mold?.id) return;
        const noteRef = doc(db, MOLD_NOTES_COLLECTION, mold.id);
        const unsub = onSnapshot(noteRef, (snapshot) => {
          if (snapshot.exists()) {
            setNoteText(snapshot.data().text || '');
          } else {
            setNoteText('');
          }
        });
        return () => unsub();
    }, [db, mold?.id]);
    
    // YENİ: Notu Firestore'a kaydet (GÜNCELLENDİ)
    const handleSaveNote = async () => {
        // ... (Mevcut fonksiyon - değişiklik yok)
        if (!db || !mold?.id || !newNoteContent.trim()) {
            if (!newNoteContent.trim()) {
                setIsNoteModalOpen(false);
            }
            return;
        }
        setIsSaving(true);
        const today = new Date().toLocaleString('tr-TR', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
        const newEntry = `--- ${today} (${loggedInUser.name}) ---\n${newNoteContent.trim()}`;
        const separator = noteText.trim().length > 0 ? '\n\n--------------------\n\n' : '';
        const updatedFullText = `${newEntry}${separator}${noteText}`;

        try {
          await setDoc(doc(db, MOLD_NOTES_COLLECTION, mold.id), {
            text: updatedFullText,
            moldName: mold.moldName || '',
            updatedAt: getCurrentDateTimeString(),
          });
          setNewNoteContent('');
        } catch (err) {
          console.error('Not kaydedilemedi:', err);
        } finally {
          setIsSaving(false);
          setIsNoteModalOpen(false);
        }
    };
    
    // YENİ: Not modalını açarken yeni not alanını temizle
    const openNoteModal = () => {
        setNewNoteContent('');
        setIsNoteModalOpen(true);
    };


    const currentMoldStatus = mold.status || MOLD_STATUS.WAITING;
    const isAdmin = loggedInUser.role === ROLES.ADMIN;

    const onStatusChange = (e) => {
        handleUpdateMoldStatus(mold.id, e.target.value);
    };

    // YENİ: Termin tarihi değiştirildiğinde
    const onDeadlineChange = (e) => {
        const newDeadline = e.target.value;
        setLocalDeadline(newDeadline);
        handleUpdateMoldDeadline(mold.id, newDeadline);
    };

    // GÜNCELLEME: Modal açma mantığı
    const handleOpenModal = (type, mold, task, operation) => {
        setModalState({ isOpen: true, type, data: { mold, task, operation } });
    };

    const handleCloseModal = () => {
        setModalState({ isOpen: false, type: null, data: null });
    };

    // GÜNCELLEME: Modal render mantığı
    const renderModal = () => {
        const { isOpen, type, data } = modalState;
        if (!isOpen || !data) return null;

        const { mold, task, operation } = data;
        
        // Operasyon Atama (CAM)
        if (type === 'assign' && loggedInUser.role === ROLES.CAM_OPERATOR && operation.status === OPERATION_STATUS.NOT_STARTED) {
            return (
                <AssignOperationModal
                    isOpen={isOpen}
                    onClose={handleCloseModal}
                    mold={mold}
                    task={task}
                    operation={operation}
                    loggedInUser={loggedInUser}
                    onSubmit={handleUpdateOperation} // handleUpdateOperation
                    projects={projects}
                    personnel={personnel}
                    machines={machines}
                />
            );
        }
        
        // Değerlendirme (Yetkili)
        if (type === 'review' && loggedInUser.role === ROLES.SUPERVISOR && operation.status === OPERATION_STATUS.WAITING_SUPERVISOR_REVIEW) {
            return (
                <SupervisorReviewModal
                    isOpen={isOpen}
                    onClose={handleCloseModal}
                    mold={mold}
                    task={task}
                    operation={operation}
                    onSubmit={handleUpdateOperation} // handleUpdateOperation
                />
            );
        }
        
        // YENİ: Admin - Yeni Operasyon Ekleme
        if (type === 'add_operation' && isAdmin) {
            return (
                <AddOperationModal
                    isOpen={isOpen}
                    onClose={handleCloseModal}
                    mold={mold}
                    task={task}
                    onSubmit={handleAddOperation} // handleAddOperation
                />
            );
        }

        return null;
    };

    return (
        <div className="p-4 bg-white dark:bg-gray-800 rounded-xl shadow-xl relative">
            <button 
                onClick={onBack} 
                className="mb-4 text-blue-600 dark:text-blue-400 hover:underline flex items-center"
            >
                &larr; Kalıp Listesine Geri Dön
            </button>
            
            <button
                onClick={openNoteModal}
                className="absolute top-4 right-4 flex items-center px-3 py-2 text-sm font-semibold text-blue-700 dark:text-blue-300 bg-blue-100 dark:bg-blue-900/40 rounded-lg hover:bg-blue-200 dark:hover:bg-blue-800 transition z-10"
                title="Kalıp Notları"
            >
                <StickyNote className="w-4 h-4 mr-2" /> Notlar
            </button>
            
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">{mold.moldName} Kalıp Detayları</h2>
            
            {/* Durum Kontrolü VE Termin Tarihi */}
            <div className="text-gray-600 dark:text-gray-400 mb-6 flex flex-wrap items-center gap-4">
                <div>
                    <span>Müşteri: {mold.customer} | Ana Durum:</span>
                    {isAdmin ? (
                        <select
                            value={currentMoldStatus}
                            onChange={onStatusChange}
                            className={`ml-2 px-3 py-1 rounded-lg text-xs font-semibold appearance-none border-2 border-gray-300 dark:border-gray-600 focus:ring-2 focus:ring-blue-500 focus:outline-none ${getStatusClasses(currentMoldStatus)}`}
                        >
                            <option value={MOLD_STATUS.WAITING}>BEKLEMEDE</option>
                            <option value={MOLD_STATUS.CNC}>CNC</option>
                            <option value={MOLD_STATUS.EREZYON}>EREZYON</option>
                            <option value={MOLD_STATUS.POLISAJ}>POLİSAJ</option>
                            <option value={MOLD_STATUS.DESEN}>DESEN</option>
                            <option value={MOLD_STATUS.MOLD_ASSEMBLY}>KALIP MONTAJ</option>
                            <option value={MOLD_STATUS.TRIAL}>DENEME'DE</option>
                            <option value={MOLD_STATUS.REVISION}>REVİZYON</option>
                            <option value={MOLD_STATUS.COMPLETED}>TAMAMLANDI</option>
                        </select>
                    ) : (
                        <span className={`ml-2 px-2 py-0.5 rounded-full text-xs font-semibold ${getStatusClasses(currentMoldStatus)}`}>
                            {currentMoldStatus}
                        </span>
                    )}
                </div>
                
                {isAdmin ? (
                    <div className="flex items-center gap-2">
                        <label htmlFor="moldDeadline" className="text-sm font-medium">Kalıp Termini:</label>
                        <input
                            type="date"
                            id="moldDeadline"
                            value={localDeadline}
                            onChange={onDeadlineChange}
                            className="px-3 py-1 rounded-lg text-xs font-semibold appearance-none border-2 border-gray-300 dark:border-gray-600 focus:ring-2 focus:ring-blue-500 focus:outline-none bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-200"
                        />
                    </div>
                ) : (
                    mold.moldDeadline && (
                        <span className="text-sm">
                            Kalıp Termini: <span className="font-semibold">{formatDate(mold.moldDeadline)}</span>
                        </span>
                    )
                )}
            </div>


            <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">İş Parçaları</h3>
            <div className="space-y-6">
                {mold.tasks.length === 0 ? (
                    <p className="text-gray-500 dark:text-gray-400">Bu kalıba atanmış alt parça bulunmamaktadır.</p>
                ) : (
                    mold.tasks.map(task => {
                        // YENİ: Son operasyonun tamamlanıp tamamlanmadığını kontrol et
                        const lastOperation = task.operations[task.operations.length - 1];
                        const canAddOperation = lastOperation.status === OPERATION_STATUS.COMPLETED;
                        
                        return (
                            <div key={task.id} className="p-4 border border-gray-200 dark:border-gray-700 rounded-lg bg-gray-50 dark:bg-gray-800 shadow-md">
                                {/* PARÇA BAŞLIĞI */}
                                <div className="flex justify-between items-center mb-3">
                                    <p className="font-bold text-lg text-gray-900 dark:text-white truncate">
                                        <span className="font-bold mr-2 text-blue-600">#{task.taskNumber}</span> {task.taskName}
                                    </p>
                                    {/* YENİ: Admin için Yeni Operasyon Ekle Butonu */}
                                    {isAdmin && canAddOperation && (
                                        <button
                                            onClick={() => handleOpenModal('add_operation', mold, task, null)}
                                            className="ml-4 px-3 py-1 bg-green-600 text-white text-xs font-medium rounded-lg hover:bg-green-700 transition flex items-center shadow-md"
                                        >
                                            <Plus className="w-4 h-4 mr-1"/> Yeni Operasyon Ekle
                                        </button>
                                    )}
                                </div>
                                
                                {/* OPERASYON LİSTESİ */}
                                <div className="space-y-3 pl-4 border-l-2 border-gray-300 dark:border-gray-600">
                                    {(task.operations || []).map(operation => (
                                        <div key={operation.id} className="p-3 border border-gray-200 dark:border-gray-700 rounded-lg flex flex-col md:flex-row justify-between items-start md:items-center bg-white dark:bg-gray-700">
                                            <div className="flex-1 min-w-0 mb-2 md:mb-0">
                                                {/* Operasyon Tipi */}
                                                <p className="font-semibold text-blue-700 dark:text-blue-300">
                                                    Operasyon: {operation.type}
                                                </p>
                                                
                                                {/* YENİ: Grid (Satır-Sütun) Layout (DÜZENLENDİ) */}
                                                <div className="grid grid-cols-2 gap-x-4 gap-y-1 mt-2 text-xs text-gray-600 dark:text-gray-400">
                                                    {/* Row 1 */}
                                                    <div className="col-span-1">
                                                        <span className="font-medium">CAM Operatörü: </span>
                                                        <span className="font-semibold text-gray-800 dark:text-gray-200">{operation.assignedOperator}</span>
                                                    </div>
                                                    
                                                    <div className="col-span-1">
                                                        <span className="font-medium">Tezgah / Operatör: </span>
                                                        <span className="font-semibold text-gray-800 dark:text-gray-200">
                                                            {operation.machineName || 'YOK'} / {operation.machineOperatorName || 'SEÇİLMEMİŞ'}
                                                        </span>
                                                    </div>

                                                    {/* Row 2 */}
                                                    <div className="col-span-1">
                                                        <span className="font-medium">Başlangıç Tarihi: </span>
                                                        <span className="font-semibold text-gray-800 dark:text-gray-200">{formatDateTime(operation.startDate)}</span>
                                                    </div>
                                                    
                                                    <div className="col-span-1">
                                                        <span className="font-medium">Tahmini Bitiş: </span>
                                                        <span className="font-semibold text-gray-800 dark:text-gray-200">{formatDate(operation.estimatedDueDate)}</span>
                                                    </div>

                                                    {/* Row 3 (Sadece doluysa) */}
                                                    {operation.durationInHours && (
                                                        <div className="col-span-1">
                                                            <span className="font-medium text-green-700 dark:text-green-300">İş Süresi: </span>
                                                            <span className="font-semibold text-green-700 dark:text-green-300">
                                                                {operation.durationInHours} Saat
                                                            </span>
                                                        </div>
                                                    )}
                                                    {operation.camOperatorRatingForMachineOp && (
                                                        <div className="col-span-1">
                                                            <span className="font-medium text-blue-600 dark:text-blue-400">CAM'in Puanı: </span>
                                                            <span className="font-semibold text-blue-600 dark:text-blue-400">
                                                                {operation.camOperatorRatingForMachineOp} / 10
                                                            </span>
                                                        </div>
                                                    )}

                                                    {/* Row 4 (Sadece doluysa) */}
                                                    {operation.supervisorRating && (
                                                        <div className="col-span-1">
                                                            <span className="font-medium text-purple-600 dark:text-purple-400">Yetkili Puanı: </span>
                                                            <span className="font-bold text-lg text-purple-600 dark:text-purple-400">
                                                                {operation.supervisorRating} / 10
                                                            </span>
                                                        </div>
                                                    )}
                                                    {operation.supervisorComment && (
                                                        <div className="col-span-2">
                                                            <span className="font-medium text-purple-600 dark:text-purple-400">Yetkili Yorumu: </span>
                                                            <span className="italic text-purple-700 dark:text-purple-300">
                                                                "{operation.supervisorComment}"
                                                            </span>
                                                        </div>
                                                    )}
                                                </div>
                                                {/* YENİ LAYOUT SONU */}

                                                <span className={`mt-3 inline-block px-3 py-1 text-xs leading-5 font-semibold rounded-full ${getStatusClasses(operation.status)}`}>
                                                    {operation.status} %{operation.progressPercentage}
                                                </span>
                                            </div>
                                            
                                            {/* GÜNCELLEME: Butonlar operasyon bazlı */}
                                            {loggedInUser.role === ROLES.CAM_OPERATOR && operation.status === OPERATION_STATUS.NOT_STARTED && (
                                                <button
                                                    onClick={() => handleOpenModal('assign', mold, task, operation)}
                                                    className="ml-0 md:ml-4 px-3 py-1 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition flex items-center shadow-md"
                                                >
                                                    <Zap className="w-4 h-4 mr-1"/> İşi Kendine Ata
                                                </button>
                                            )}
                                            
                                            {loggedInUser.role === ROLES.SUPERVISOR && operation.status === OPERATION_STATUS.WAITING_SUPERVISOR_REVIEW && (
                                                <button
                                                    onClick={() => handleOpenModal('review', mold, task, operation)}
                                                    className="ml-0 md:ml-4 px-3 py-1 bg-purple-600 text-white text-sm font-medium rounded-lg hover:bg-purple-700 transition flex items-center shadow-md"
                                                >
                                                    <CheckCircle className="w-4 h-4 mr-1"/> Değerlendir
                                                </button>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )
                    })
                )}
            </div>
            
            {renderModal()}
            
            {/* Notlar Modal */}
            <Modal
                isOpen={isNoteModalOpen}
                onClose={() => setIsNoteModalOpen(false)}
                title={`${mold.moldName} - Ortak Notlar`}
            >
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Yeni Not Ekle ({loggedInUser.name})
                </label>
                <textarea
                  value={newNoteContent}
                  onChange={(e) => setNewNoteContent(e.target.value)}
                  placeholder="Yeni notunuzu buraya yazın..."
                  className="w-full h-24 p-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-white resize-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                
                <div className="mt-4 mb-6 flex justify-end">
                  <button
                    onClick={handleSaveNote}
                    disabled={isSaving || !newNoteContent.trim()}
                    className="px-4 py-2 text-sm font-medium bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition flex items-center disabled:opacity-50"
                  >
                    <Save className="w-4 h-4 mr-2" /> {isSaving ? 'Kaydediliyor...' : 'Yeni Notu Kaydet'}
                  </button>
                </div>

                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Not Geçmişi
                </label>
                <div className="w-full h-48 p-3 border border-gray-200 dark:border-gray-700 rounded-lg bg-gray-100 dark:bg-gray-900 overflow-y-auto">
                    {noteText.trim().length > 0 ? (
                        <pre className="text-sm text-gray-800 dark:text-gray-300 whitespace-pre-wrap font-sans">
                            {noteText}
                        </pre>
                    ) : (
                        <p className="text-sm text-gray-500 dark:text-gray-400">Bu kalıp için henüz not girilmemiş.</p>
                    )}
                </div>
                
                <div className="mt-4 flex justify-end">
                  <button
                    onClick={() => setIsNoteModalOpen(false)}
                    className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition"
                  >
                    Kapat
                  </button>
                </div>
            </Modal>
        </div>
    );
};

// GÜNCELLEME: Artık operasyonları listeliyor
const CamDashboard = ({ loggedInUser, projects, handleUpdateOperation, personnel, machines }) => {
    const [modalState, setModalState] = useState({ isOpen: false, type: null, data: null });

    // GÜNCELLEME: Operasyonları al
    const camOperations = useMemo(() => {
        return projects.flatMap(mold => 
            mold.tasks.flatMap(task => 
                task.operations
                    .filter(op => 
                        op.assignedOperator === loggedInUser.name && op.status !== OPERATION_STATUS.COMPLETED
                    )
                    .map(op => ({ 
                        ...op, 
                        moldName: mold.moldName, 
                        moldId: mold.id, 
                        taskName: task.taskName,
                        taskId: task.id 
                    }))
            )
        ).sort((a, b) => a.status.localeCompare(b.status) || (a.estimatedDueDate || 'zzzz').localeCompare(b.estimatedDueDate || 'zzzz'));
    }, [projects, loggedInUser.name]);

    const handleProgressClick = (mold, task, operation) => {
        setModalState({ isOpen: true, type: 'progress', data: { mold, task, operation } });
    };

    const handleNeedsMachineOpReview = (operationWithProgress) => {
        // 'data'da zaten mold, task var, operation'ı güncelle
        setModalState(prevState => ({
            isOpen: true,
            type: 'cam_review',
            data: { ...prevState.data, operation: operationWithProgress }
        }));
    };
    
    const handleCloseModal = () => {
        setModalState({ isOpen: false, type: null, data: null });
    };
    
    const { isOpen, type, data } = modalState;
    const { mold, task, operation } = data || {};

    return (
        <div className="p-4 bg-white dark:bg-gray-800 rounded-xl shadow-xl">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
                {loggedInUser.name} - Atanan Operasyonlarım ({camOperations.length})
            </h2>

            {camOperations.length === 0 ? (
                 <p className="text-gray-500 dark:text-gray-400">Şu anda size atanmış aktif veya değerlendirme bekleyen operasyon bulunmamaktadır. Kalıp Listesi sekmesinden yeni iş atayabilirsiniz.</p>
            ) : (
                <div className="space-y-4">
                    {camOperations.map(op => {
                        const currentMold = { id: op.moldId, name: op.moldName };
                        // DÜZELTME: 'name' yerine 'taskName' kullanan objeyi düzelt
                        const currentTask = { id: op.taskId, taskName: op.taskName, operations: [] }; // Modal'ın task.taskName'i okuyabilmesi için 'taskName' ekle
                        
                        return (
                            <div key={op.id} className="p-4 border border-gray-200 dark:border-gray-700 rounded-lg bg-gray-50 dark:bg-gray-700">
                                <div className="flex justify-between items-start">
                                    <div className="flex-1 min-w-0">
                                        <p className="font-semibold text-lg text-gray-900 dark:text-white">{op.taskName}</p>
                                        <p className="text-sm font-bold text-blue-600 dark:text-blue-400">{op.type}</p>
                                        <p className="text-sm text-gray-600 dark:text-gray-400">Kalıp: <span className="font-medium">{op.moldName}</span></p>
                                        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                                            Tezgah: {op.machineName} | Tezgah Operatörü: {op.machineOperatorName}
                                        </p>
                                        <p className="text-xs text-gray-500 dark:text-gray-400">
                                            Başlangıç: {formatDateTime(op.startDate)} | Termin: {formatDate(op.estimatedDueDate)}
                                        </p>
                                    </div>
                                    <div className="flex flex-col items-end space-y-2 ml-4">
                                        <span className={`px-3 py-1 text-xs leading-5 font-semibold rounded-full ${getStatusClasses(op.status)}`}>
                                            {op.status}
                                        </span>
                                        {op.status === OPERATION_STATUS.IN_PROGRESS && (
                                            <button
                                                onClick={() => handleProgressClick(currentMold, currentTask, op)}
                                                className="px-3 py-1 bg-green-500 text-white text-sm font-medium rounded-lg hover:bg-green-600 transition flex items-center"
                                            >
                                                <Edit2 className="w-4 h-4 mr-1"/> İlerleme (%{op.progressPercentage})
                                            </button>
                                        )}
                                        {op.status === OPERATION_STATUS.WAITING_SUPERVISOR_REVIEW && (
                                            <div className="p-2 bg-yellow-100 text-yellow-800 text-xs font-medium rounded-lg dark:bg-yellow-900 dark:text-yellow-300">
                                                Yetkili Değerlendirmesi Bekleniyor
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700 mt-3">
                                    <div 
                                        className={`h-2.5 rounded-full ${op.status === OPERATION_STATUS.WAITING_SUPERVISOR_REVIEW ? 'bg-yellow-500' : 'bg-blue-600'}`} 
                                        style={{ width: `${op.progressPercentage}%` }}
                                    ></div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            )}
            
            {isOpen && type === 'progress' && (
                <ProgressUpdateModal
                    isOpen={isOpen}
                    onClose={handleCloseModal}
                    mold={mold}
                    task={task}
                    operation={operation}
                    onSubmit={handleUpdateOperation}
                    onNeedsMachineOpReview={handleNeedsMachineOpReview}
                />
            )}

            {isOpen && type === 'cam_review' && (
                <CamReviewMachineOpModal
                    isOpen={isOpen}
                    onClose={handleCloseModal}
                    mold={mold}
                    task={task}
                    operation={operation}
                    onSubmit={handleUpdateOperation}
                />
            )}
        </div>
    );
};

// GÜNCELLEME: Artık operasyonları listeliyor
const SupervisorReviewPage = ({ projects, loggedInUser, handleUpdateOperation }) => {
    const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);
    const [operationToReview, setOperationToReview] = useState(null);

    const tasksToReview = useMemo(() => {
        return projects.flatMap(mold => 
            mold.tasks.flatMap(task => 
                task.operations
                    .filter(op => op.status === OPERATION_STATUS.WAITING_SUPERVISOR_REVIEW)
                    .map(op => ({ 
                        ...op, 
                        moldName: mold.moldName, 
                        moldId: mold.id, 
                        taskName: task.taskName,
                        taskId: task.id 
                    }))
            )
        ).sort((a, b) => new Date(a.camOperatorReviewDate) - new Date(b.camOperatorReviewDate));
    }, [projects]);

    const handleReviewClick = (op) => {
        setOperationToReview(op);
        setIsReviewModalOpen(true);
    };

    return (
        <div className="p-4 bg-white dark:bg-gray-800 rounded-xl shadow-xl">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
                Bitmiş İşler - Kontrol ve Değerlendirme ({tasksToReview.length})
            </h2>

            {tasksToReview.length === 0 ? (
                 <p className="text-gray-500 dark:text-gray-400">Şu anda değerlendirilmeyi bekleyen, CAM operatörü onaylı iş parçası bulunmamaktadır.</p>
            ) : (
                <div className="space-y-4">
                    {tasksToReview.map(op => (
                        <div key={op.id} className="p-4 border border-yellow-300 dark:border-yellow-700 rounded-lg bg-yellow-50 dark:bg-yellow-900/10">
                            <div className="flex justify-between items-center">
                                <div className="flex-1 min-w-0">
                                    <p className="font-semibold text-lg text-gray-900 dark:text-white">{op.taskName}</p>
                                    <p className="text-sm font-bold text-yellow-700 dark:text-yellow-400">{op.type}</p>
                                    <p className="text-sm text-gray-600 dark:text-gray-400">Kalıp: <span className="font-medium">{op.moldName}</span></p>
                                    <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                                        CAM Operatörü: {op.assignedOperator} | CAM Onayı: {formatDateTime(op.camOperatorReviewDate)}
                                    </p>
                                    <p className="text-xs text-gray-500 dark:text-gray-400">
                                        İş Süresi (CAM): <span className="font-semibold">{op.durationInHours} Saat</span>
                                    </p>
                                </div>
                                <button
                                    onClick={() => handleReviewClick(op)}
                                    className="ml-4 px-3 py-1 bg-purple-600 text-white text-sm font-medium rounded-lg hover:bg-purple-700 transition flex items-center"
                                >
                                    <CheckCircle className="w-4 h-4 mr-1"/> Değerlendir (1-10)
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
            
            {isReviewModalOpen && operationToReview && (
                <SupervisorReviewModal
                    isOpen={isReviewModalOpen}
                    onClose={() => setIsReviewModalOpen(false)}
                    mold={{ id: operationToReview.moldId }}
                    task={{ id: operationToReview.taskId, taskName: operationToReview.taskName }}
                    operation={operationToReview}
                    onSubmit={handleUpdateOperation}
                />
            )}
        </div>
    );
};

// --- YENİ: PARÇA LİSTESİ BİLEŞENİ ---
const TaskListSidebar = ({ tasks, onDeleteTask, selectedMoldId }) => {
    // ... (Mevcut bileşen - değişiklik yok, bu hala TASK (ana parça) siliyor)
    const [taskToDelete, setTaskToDelete] = useState(null);

    const handleDeleteClick = (task) => {
        setTaskToDelete(task);
    };

    const handleConfirmDelete = async () => {
        if (taskToDelete && selectedMoldId) {
            await onDeleteTask(selectedMoldId, taskToDelete.id);
            setTaskToDelete(null);
        }
    };

    const handleCancelDelete = () => {
        setTaskToDelete(null);
    };

    // GÜNCELLEME: Parçanın genel durumunu göster
    const getOverallTaskStatus = (operations) => {
        if (!operations || operations.length === 0) return "Bilinmiyor";
        if (operations.every(op => op.status === OPERATION_STATUS.COMPLETED)) return "TAMAMLANDI";
        if (operations.some(op => op.status === OPERATION_STATUS.IN_PROGRESS)) return "ÇALIŞIYOR";
        if (operations.some(op => op.status === OPERATION_STATUS.WAITING_SUPERVISOR_REVIEW)) return "ONAY BEKLİYOR";
        return "BAŞLAMADI";
    };

    return (
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700">
            <div className="p-4 border-b border-gray-200 dark:border-gray-700">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white flex items-center">
                    <List className="w-5 h-5 mr-2" />
                    Mevcut Parçalar ({tasks.length})
                </h3>
            </div>
            
            <div className="max-h-96 overflow-y-auto">
                {tasks.length === 0 ? (
                    <div className="p-4 text-center text-gray-500 dark:text-gray-400">
                        Bu kalıpta henüz parça bulunmuyor
                    </div>
                ) : (
                    <div className="divide-y divide-gray-200 dark:divide-gray-700">
                        {tasks.map((task, index) => {
                            const overallStatus = getOverallTaskStatus(task.operations);
                            return (
                                <div key={task.id} className="p-3 hover:bg-gray-50 dark:hover:bg-gray-700/50 transition">
                                    <div className="flex justify-between items-start">
                                        <div className="flex-1 min-w-0">
                                            <p className="text-sm font-medium text-gray-900 dark:text-white truncate">
                                                {index + 1}. {task.taskName}
                                            </p>
                                            <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                                                Durum: <span className={`px-1 py-0.5 rounded text-xs ${getStatusClasses(overallStatus)}`}>
                                                    {overallStatus}
                                                </span>
                                                <span className="ml-2">({task.operations.length} Op.)</span>
                                            </p>
                                        </div>
                                        <button
                                            onClick={() => handleDeleteClick(task)}
                                            className="ml-2 p-1 text-red-600 hover:text-red-800 dark:text-red-400 dark:hover:text-red-300 transition"
                                            title="Parçayı Sil"
                                        >
                                            <Trash2 className="w-4 h-4" />
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>

            {/* Silme Onay Modalı */}
            {taskToDelete && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white dark:bg-gray-800 rounded-lg p-6 max-w-sm w-full">
                        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                            Parçayı Sil
                        </h3>
                        <p className="text-gray-600 dark:text-gray-400 mb-4">
                            "{taskToDelete.taskName}" parçasını (ve içindeki tüm operasyonları) silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.
                        </p>
                        <div className="flex justify-end space-x-3">
                            <button
                                onClick={handleCancelDelete}
                                className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-200 dark:bg-gray-700 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition"
                            >
                                İptal
                            </button>
                            <button
                                onClick={handleConfirmDelete}
                                className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition flex items-center"
                            >
                                <Trash2 className="w-4 h-4 mr-2" />
                                Sil
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

// --- GÜNCELLENMİŞ: PERSONEL YÖNETİMİ BİLEŞENİ ---
const PersonnelManagement = ({ db, personnel, setPersonnel, machines, setMachines }) => {
    // ... (Mevcut bileşen - değişiklik yok)
    const [newPersonnel, setNewPersonnel] = useState({ name: '', role: PERSONNEL_ROLES.CAM_OPERATOR, username: '', password: '' });
    const [newMachine, setNewMachine] = useState('');
    const [editingMachine, setEditingMachine] = useState(null);
    const [editMachineName, setEditMachineName] = useState('');
    const [editingPersonnel, setEditingPersonnel] = useState(null);
    const [editPersonnelData, setEditPersonnelData] = useState({ name: '', role: '', username: '', password: '' });
    
    const handleAddPersonnel = async () => {
        if (!newPersonnel.name.trim()) return;
        const isLoginRole = newPersonnel.role !== PERSONNEL_ROLES.MACHINE_OPERATOR;
        if (isLoginRole && (!newPersonnel.username.trim() || !newPersonnel.password.trim())) {
            alert("Yönetici, CAM Operatörü veya Yetkili rolleri için Kullanıcı Adı ve Şifre zorunludur.");
            return;
        }
        const personnelId = `person-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
        const personnelData = {
            id: personnelId,
            name: newPersonnel.name.trim(),
            role: newPersonnel.role,
            createdAt: getCurrentDateTimeString(),
            username: isLoginRole ? newPersonnel.username.trim() : null,
            password: isLoginRole ? newPersonnel.password.trim() : null,
        };
        try {
            await setDoc(doc(db, PERSONNEL_COLLECTION, personnelId), personnelData);
            setNewPersonnel({ name: '', role: PERSONNEL_ROLES.CAM_OPERATOR, username: '', password: '' });
        } catch (error) { console.error("Personel eklenirken hata:", error); }
    };

    const handleDeletePersonnel = async (personnelId) => {
        try { await deleteDoc(doc(db, PERSONNEL_COLLECTION, personnelId)); }
        catch (error) { console.error("Personel silinirken hata:", error); }
    };

    const handleEditPersonnelClick = (person) => {
        setEditingPersonnel(person);
        setEditPersonnelData({ name: person.name, role: person.role, username: person.username || '', password: person.password || '' });
    };
    
    const handleUpdatePersonnel = async () => {
        if (!editingPersonnel || !editPersonnelData.name.trim()) return;
        const isLoginRole = editPersonnelData.role !== PERSONNEL_ROLES.MACHINE_OPERATOR;
        if (isLoginRole && (!editPersonnelData.username.trim() || !editPersonnelData.password.trim())) {
             alert("Yönetici, CAM Operatörü veya Yetkili rolleri için Kullanıcı Adı ve Şifre zorunludur.");
            return;
        }
        const updatedData = {
            name: editPersonnelData.name.trim(),
            role: editPersonnelData.role,
            username: isLoginRole ? editPersonnelData.username.trim() : null,
            password: isLoginRole ? editPersonnelData.password.trim() : null,
        };
        try {
            await updateDoc(doc(db, PERSONNEL_COLLECTION, editingPersonnel.id), updatedData);
            setEditingPersonnel(null);
            setEditPersonnelData({ name: '', role: '', username: '', password: '' });
        } catch (error) { console.error("Personel güncellenirken hata:", error); }
    };

    const handleAddMachine = async () => {
        if (!newMachine.trim()) return;
        const machineId = `machine-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
        const machineData = { id: machineId, name: newMachine.trim(), createdAt: getCurrentDateTimeString() };
        try {
            await setDoc(doc(db, MACHINES_COLLECTION, machineId), machineData);
            setNewMachine('');
        } catch (error) { console.error("Tezgah eklenirken hata:", error); }
    };

    const handleEditMachine = (machine) => {
        setEditingMachine(machine);
        setEditMachineName(machine.name);
    };

    const handleUpdateMachine = async () => {
        if (!editMachineName.trim() || !editingMachine) return;
        try {
            await updateDoc(doc(db, MACHINES_COLLECTION, editingMachine.id), { name: editMachineName.trim() });
            setEditingMachine(null);
            setEditMachineName('');
        } catch (error) { console.error("Tezgah güncellenirken hata:", error); }
    };

    const handleDeleteMachine = async (machineId) => {
        try { await deleteDoc(doc(db, MACHINES_COLLECTION, machineId)); }
        catch (error) { console.error("Tezgah silinirken hata:", error); }
    };
    
    const isNewPersonnelLoginRole = newPersonnel.role !== PERSONNEL_ROLES.MACHINE_OPERATOR;

    return (
        <div className="space-y-8">
            {/* Personel Yönetimi */}
            <div className="p-6 border border-blue-200 dark:border-blue-700 rounded-lg bg-blue-50 dark:bg-blue-900/10">
                <h3 className="text-xl font-semibold dark:text-white mb-4 flex items-center">
                    <Users className="w-6 h-6 mr-2" />
                    Personel Yönetimi
                </h3>
                
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6 items-end">
                    <input type="text" placeholder="Personel Adı Soyadı" value={newPersonnel.name} onChange={(e) => setNewPersonnel({ ...newPersonnel, name: e.target.value })}
                        className="rounded-lg border-gray-300 dark:bg-gray-700 dark:border-gray-600 dark:text-white px-3 py-2" />
                    <select value={newPersonnel.role} onChange={(e) => setNewPersonnel({ ...newPersonnel, role: e.target.value })}
                        className="rounded-lg border-gray-300 dark:bg-gray-700 dark:border-gray-600 dark:text-white px-3 py-2">
                        {Object.values(PERSONNEL_ROLES).map(role => (<option key={role} value={role}>{role}</option>))}
                    </select>
                     <button onClick={handleAddPersonnel} disabled={!newPersonnel.name.trim()}
                        className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition font-medium disabled:opacity-50">
                        Personel Ekle
                    </button>
                    
                    {isNewPersonnelLoginRole && (
                        <>
                            <input type="text" placeholder="Kullanıcı Adı" value={newPersonnel.username} onChange={(e) => setNewPersonnel({ ...newPersonnel, username: e.target.value })}
                                className="rounded-lg border-gray-300 dark:bg-gray-700 dark:border-gray-600 dark:text-white px-3 py-2" />
                            <input type="text" placeholder="Şifre (Güvensiz)" value={newPersonnel.password} onChange={(e) => setNewPersonnel({ ...newPersonnel, password: e.target.value })}
                                className="rounded-lg border-gray-300 dark:bg-gray-700 dark:border-gray-600 dark:text-white px-3 py-2" />
                             <div className="flex items-center text-xs text-red-600 dark:text-red-400">
                                <AlertTriangle className="w-4 h-4 mr-1 flex-shrink-0" />
                                Şifreler güvensiz olarak saklanır!
                            </div>
                        </>
                    )}
                </div>

                <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                    <h4 className="p-4 border-b border-gray-200 dark:border-gray-700 font-semibold">
                        Mevcut Personel ({personnel.length})
                    </h4>
                    <div className="max-h-64 overflow-y-auto">
                        {personnel.length === 0 ? (
                            <p className="p-4 text-center text-gray-500 dark:text-gray-400">Henüz personel bulunmuyor</p>
                        ) : (
                            <div className="divide-y divide-gray-200 dark:divide-gray-700">
                                {personnel.map((person) => (
                                    <div key={person.id} className="p-4 flex justify-between items-center">
                                        <div>
                                            <p className="font-medium text-gray-900 dark:text-white">{person.name}</p>
                                            <p className="text-sm text-gray-500 dark:text-gray-400">{person.role}</p>
                                            {person.username && (<p className="text-xs text-blue-500 dark:text-blue-400">K.Adı: {person.username}</p>)}
                                        </div>
                                        <div className="flex space-x-2">
                                            <button onClick={() => handleEditPersonnelClick(person)} className="p-2 text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 transition" title="Düzenle">
                                                <Edit2 className="w-4 h-4" />
                                            </button>
                                            <button onClick={() => handleDeletePersonnel(person.id)} className="p-2 text-red-600 hover:text-red-800 dark:text-red-400 dark:hover:text-red-300 transition" title="Sil">
                                                <Trash2 className="w-4 h-4" />
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            
            {editingPersonnel && (
                <Modal isOpen={!!editingPersonnel} onClose={() => setEditingPersonnel(null)} title={`Personel Düzenle: ${editingPersonnel.name}`}>
                    <div className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Adı Soyadı</label>
                            <input type="text" value={editPersonnelData.name} onChange={(e) => setEditPersonnelData({ ...editPersonnelData, name: e.target.value })}
                                className="mt-1 block w-full rounded-lg border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white" />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Rol</label>
                            <select value={editPersonnelData.role} onChange={(e) => setEditPersonnelData({ ...editPersonnelData, role: e.target.value })}
                                className="mt-1 block w-full rounded-lg border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                                {Object.values(PERSONNEL_ROLES).map(role => (<option key={role} value={role}>{role}</option>))}
                            </select>
                        </div>
                        
                        {editPersonnelData.role !== PERSONNEL_ROLES.MACHINE_OPERATOR && (
                            <>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Kullanıcı Adı</label>
                                    <input type="text" value={editPersonnelData.username} onChange={(e) => setEditPersonnelData({ ...editPersonnelData, username: e.target.value })}
                                        className="mt-1 block w-full rounded-lg border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white" />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Şifre</label>
                                    <input type="text" value={editPersonnelData.password} onChange={(e) => setEditPersonnelData({ ...editPersonnelData, password: e.target.value })}
                                        className="mt-1 block w-full rounded-lg border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white" />
                                </div>
                            </>
                        )}
                    </div>
                    <div className="mt-6 flex justify-end space-x-3">
                        <button onClick={() => setEditingPersonnel(null)}
                            className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-200 dark:bg-gray-700 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition">
                            İptal
                        </button>
                        <button onClick={handleUpdatePersonnel}
                            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition">
                            Kaydet
                        </button>
                    </div>
                </Modal>
            )}

            {/* Tezgah Yönetimi */}
            <div className="p-6 border border-green-200 dark:border-green-700 rounded-lg bg-green-50 dark:bg-green-900/10">
                <h3 className="text-xl font-semibold dark:text-white mb-4 flex items-center">
                    <Cpu className="w-6 h-6 mr-2" />
                    Tezgah Yönetimi
                </h3>
                
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
                    <input type="text" placeholder="Yeni Tezgah Kodu" value={newMachine} onChange={(e) => setNewMachine(e.target.value)}
                        className="rounded-lg border-gray-300 dark:bg-gray-700 dark:border-gray-600 dark:text-white px-3 py-2 md:col-span-3" />
                    <button onClick={handleAddMachine} disabled={!newMachine.trim()}
                        className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition font-medium disabled:opacity-50">
                        Tezgah Ekle
                    </button>
                </div>

                <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                    <h4 className="p-4 border-b border-gray-200 dark:border-gray-700 font-semibold">
                        Mevcut Tezgahlar ({machines.length})
                    </h4>
                    <div className="max-h-64 overflow-y-auto">
                        {machines.length === 0 ? (
                            <p className="p-4 text-center text-gray-500 dark:text-gray-400">Henüz tezgah bulunmuyor</p>
                        ) : (
                            <div className="divide-y divide-gray-200 dark:divide-gray-700">
                                {machines.map((machine) => (
                                    <div key={machine.id} className="p-4 flex justify-between items-center">
                                        {editingMachine?.id === machine.id ? (
                                            <div className="flex-1 flex gap-2">
                                                <input type="text" value={editMachineName} onChange={(e) => setEditMachineName(e.target.value)}
                                                    className="flex-1 rounded-lg border-gray-300 dark:bg-gray-700 dark:border-gray-600 dark:text-white px-3 py-2" />
                                                <button onClick={handleUpdateMachine} className="px-3 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition text-sm">
                                                    Kaydet
                                                </button>
                                                <button onClick={() => setEditingMachine(null)} className="px-3 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition text-sm">
                                                    İptal
                                                </button>
                                            </div>
                                        ) : (
                                            <>
                                                <p className="font-medium text-gray-900 dark:text-white">{machine.name}</p>
                                                <div className="flex gap-2">
                                                    <button onClick={() => handleEditMachine(machine)} className="p-2 text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 transition">
                                                        <Edit2 className="w-4 h-4" />
                                                    </button>
                                                    <button onClick={() => handleDeleteMachine(machine.id)} className="p-2 text-red-600 hover:text-red-800 dark:text-red-400 dark:hover:text-red-300 transition">
                                                        <Trash2 className="w-4 h-4" />
                                                    </button>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

// --- (GÜNCELLENMİŞ) ADMIN DASHBOARD ---
const AdminDashboard = ({ db, projects, setProjects, personnel, setPersonnel, machines, setMachines }) => {
    const [newMoldName, setNewMoldName] = useState('');
    const [newCustomer, setNewCustomer] = useState('');
    const [newTaskName, setNewTaskName] = useState('');
    const [batchTaskNames, setBatchTaskNames] = useState('');
    const [selectedMoldId, setSelectedMoldId] = useState('');
    const [moldError, setMoldError] = useState('');
    const [batchError, setBatchError] = useState('');
    const [activeTab, setActiveTab] = useState('projects');

    // Aynı kalıp ismi kontrolü
    const checkDuplicateMold = (moldName) => {
        return projects.some(project => 
            project.moldName.toLowerCase() === moldName.toLowerCase().trim()
        );
    };

    // Aynı parça ismi kontrolü
    const checkDuplicateTask = (moldId, taskName) => {
        const mold = projects.find(p => p.id === moldId);
        if (!mold) return false;
        
        return mold.tasks.some(task => 
            task.taskName.toLowerCase() === taskName.toLowerCase().trim()
        );
    };

    const handleAddNewMold = async () => {
        if (!newMoldName || !newCustomer) return;
        
        if (checkDuplicateMold(newMoldName)) {
            setMoldError(`⚠️ "${newMoldName}" isminde bir kalıp zaten mevcut!`);
            return;
        }

        const newId = `mold-${Date.now()}`;
        const newMold = {
            id: newId,
            moldName: newMoldName.trim(),
            customer: newCustomer.trim(),
            tasks: [],
            status: MOLD_STATUS.WAITING,
            moldDeadline: '',
        };
        try {
            await setDoc(doc(db, PROJECT_COLLECTION, newId), newMold);
            setNewMoldName('');
            setNewCustomer('');
            setMoldError('');
            console.log("Yeni Kalıp Eklendi:", newMold.moldName);
        } catch (e) {
            console.error("Kalıp eklenirken hata: ", e);
        }
    };
    
    // GÜNCELLEME: Artık varsayılan bir CNC operasyonu ile ekliyor
    const handleAddNewTask = async () => {
        if (!selectedMoldId || !newTaskName) return;
        
        const moldToUpdate = projects.find(p => p.id === selectedMoldId);
         if (!moldToUpdate) {
            console.error("Kalıp bulunamadı:", selectedMoldId);
            setBatchError("Hata: Kalıp bulunamadı.");
            return;
        }
        
        if (checkDuplicateTask(selectedMoldId, newTaskName)) {
            setBatchError(`⚠️ "${newTaskName}" isminde bir parça zaten mevcut!`);
            return;
        }

        const newTaskNumber = moldToUpdate.tasks.length + 1;
        
        // YENİ: Varsayılan Operasyon
        const newOperationId = `op-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
        const defaultOperation = {
            id: newOperationId,
            type: OPERATION_TYPES.CNC,
            status: OPERATION_STATUS.NOT_STARTED,
            progressPercentage: 0,
            assignedOperator: 'SEÇ',
            machineName: '',
            machineOperatorName: '', estimatedDueDate: '', startDate: '', finishDate: '', durationInHours: null, supervisorRating: null, supervisorReviewDate: null, supervisorComment: null,
            camOperatorRatingForMachineOp: null, camOperatorCommentForMachineOp: null, camOperatorReviewDate: null
        };

        // YENİ: Yeni Task Yapısı
        const newTask = {
            id: `task-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
            taskName: newTaskName.trim(),
            taskNumber: newTaskNumber,
            operations: [defaultOperation] // Operasyon dizisi ile başla
        };

        const updatedTasks = [...moldToUpdate.tasks, newTask];

        try {
            await updateDoc(doc(db, PROJECT_COLLECTION, selectedMoldId), {
                tasks: updatedTasks,
            });
            setNewTaskName('');
            setBatchError('');
            console.log("Yeni Alt Parça Eklendi (operasyonlu):", newTaskName);
        } catch (e) {
            console.error("Alt parça eklenirken hata: ", e);
            setBatchError("Hata: Parça eklenemedi.");
        }
    };

    // GÜNCELLEME: Artık varsayılan bir CNC operasyonu ile ekliyor
    const handleBatchAddTasks = async () => {
        if (!selectedMoldId || !batchTaskNames.trim()) return;

        const moldToUpdate = projects.find(p => p.id === selectedMoldId);
        if (!moldToUpdate) {
            console.error("Kalıp bulunamadı:", selectedMoldId);
            setBatchError("Hata: Kalıp bulunamadı.");
            return;
        }

        const taskNames = batchTaskNames.split('\n')
            .map(name => name.trim())
            .filter(name => name.length > 0);
        
        if (taskNames.length === 0) return;

        let newTasksList = [...moldToUpdate.tasks];
        let addedCount = 0;
        let errorMessages = [];
        let currentTaskNumber = moldToUpdate.tasks.length;

        for (const taskName of taskNames) {
            const isDuplicate = newTasksList.some(task => 
                task.taskName.toLowerCase() === taskName.toLowerCase()
            );

            if (isDuplicate) {
                errorMessages.push(`"${taskName}" (zaten var)`);
            } else {
                currentTaskNumber++;
                
                // YENİ: Varsayılan Operasyon
                const newOperationId = `op-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
                const defaultOperation = {
                    id: newOperationId,
                    type: OPERATION_TYPES.CNC,
                    status: OPERATION_STATUS.NOT_STARTED,
                    progressPercentage: 0,
                    assignedOperator: 'SEÇ',
                    machineName: '',
                    machineOperatorName: '', estimatedDueDate: '', startDate: '', finishDate: '', durationInHours: null, supervisorRating: null, supervisorReviewDate: null, supervisorComment: null,
                    camOperatorRatingForMachineOp: null, camOperatorCommentForMachineOp: null, camOperatorReviewDate: null
                };

                // YENİ: Yeni Task Yapısı
                const newTask = {
                    id: `task-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
                    taskName: taskName,
                    taskNumber: currentTaskNumber,
                    operations: [defaultOperation] // Operasyon dizisi ile başla
                };
                
                newTasksList.push(newTask);
                addedCount++;
            }
        }

        if (addedCount > 0) {
            try {
                await updateDoc(doc(db, PROJECT_COLLECTION, selectedMoldId), {
                    tasks: newTasksList,
                });
                
                setBatchTaskNames('');
                setBatchError('');
                console.log(`Toplu parça ekleme tamamlandı: ${addedCount} parça eklendi.`);
                
                if (errorMessages.length > 0) {
                    setBatchError(`ℹ️ ${addedCount} parça eklendi. ${errorMessages.join(', ')} eklenemedi (zaten mevcuttu).`);
                }

            } catch (e) {
                console.error("Toplu parça eklerken hata: ", e);
                setBatchError("Hata: Parçalar güncellenemedi.");
            }
        } else {
            setBatchTaskNames('');
            if(errorMessages.length > 0) {
                setBatchError(`⚠️ Parçalar eklenemedi. ${errorMessages.join(', ')}`);
            } else {
                setBatchError('');
            }
        }
    };
    // --- GÜNCELLEME SONU ---

    // GÜNCELLEME: Bu fonksiyon artık bir TASK'ı (ve içindeki tüm operasyonları) siler
    const handleDeleteTask = async (moldId, taskId) => {
        const moldToUpdate = projects.find(p => p.id === moldId);
        if (!moldToUpdate) return;

        const updatedTasks = moldToUpdate.tasks.filter(t => t.id !== taskId);
        const renumberedTasks = updatedTasks.map((task, index) => ({
            ...task,
            taskNumber: index + 1,
        }));
        
        try {
            await updateDoc(doc(db, PROJECT_COLLECTION, moldId), {
                tasks: renumberedTasks,
            });
            console.log("Parça silindi:", taskId);
        } catch (e) {
            console.error("Parça silinirken hata: ", e);
        }
    };

    const selectedMold = projects.find(p => p.id === selectedMoldId);

    return (
        <div className="p-4 bg-white dark:bg-gray-800 rounded-xl shadow-xl space-y-8">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Admin Paneli</h2>

            <div className="border-b border-gray-200 dark:border-gray-700">
                <nav className="flex space-x-8">
                    <button
                        onClick={() => setActiveTab('projects')}
                        className={`py-2 px-1 border-b-2 font-medium text-sm ${
                            activeTab === 'projects'
                                ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                                : 'border-transparent text-gray-500 hover:text-gray-700 dark:hover:text-gray-300'
                        }`}
                    >
                        <LayoutDashboard className="w-4 h-4 inline mr-2" />
                        Proje ve İş Ekleme
                    </button>
                    <button
                        onClick={() => setActiveTab('personnel')}
                        className={`py-2 px-1 border-b-2 font-medium text-sm ${
                            activeTab === 'personnel'
                                ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                                : 'border-transparent text-gray-500 hover:text-gray-700 dark:hover:text-gray-300'
                        }`}
                    >
                        <Users className="w-4 h-4 inline mr-2" />
                        Personel Yönetimi
                    </button>
                </nav>
            </div>

            {activeTab === 'projects' ? (
                <>
                    <div className="p-4 border border-blue-200 dark:border-blue-700 rounded-lg bg-blue-50 dark:bg-blue-900/10">
                        <h3 className="text-xl font-semibold dark:text-white mb-3 flex items-center"><Plus className="w-5 h-5 mr-2"/> Yeni Kalıp Ekle</h3>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                            <div>
                                <input 
                                    type="text" 
                                    placeholder="Kalıp Numarası (Örn: 2847 FAN)" 
                                    value={newMoldName} 
                                    onChange={(e) => {
                                        setNewMoldName(e.target.value);
                                        setMoldError('');
                                    }} 
                                    className="w-full rounded-lg border-gray-300 dark:bg-gray-700 dark:border-gray-600 dark:text-white px-3 py-2" 
                                />
                                {moldError && (
                                    <div className="mt-2 flex items-center text-sm text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-900/20 p-2 rounded-lg">
                                        <AlertTriangle className="w-4 h-4 mr-2" />
                                        {moldError}
                                    </div>
                                )}
                            </div>
                            <input type="text" placeholder="Müşteri Adı" value={newCustomer} onChange={(e) => setNewCustomer(e.target.value)} className="rounded-lg border-gray-300 dark:bg-gray-700 dark:border-gray-600 dark:text-white px-3 py-2" />
                            <button onClick={handleAddNewMold} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition font-medium disabled:opacity-50" disabled={!newMoldName || !newCustomer}>
                                Kalıp Ekle
                            </button>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                        <div className="lg:col-span-2 space-y-6">
                            <div className="p-4 border border-green-200 dark:border-green-700 rounded-lg bg-green-50 dark:bg-green-900/10">
                                <h3 className="text-xl font-semibold dark:text-white mb-3 flex items-center"><Plus className="w-5 h-5 mr-2"/> Tek Parça Ekle</h3>
                                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                                    <select value={selectedMoldId} onChange={(e) => setSelectedMoldId(e.target.value)} className="rounded-lg border-gray-300 dark:bg-gray-700 dark:border-gray-600 dark:text-white px-3 py-2 col-span-4 md:col-span-1">
                                        <option value="">Kalıp Seçiniz</option>
                                        {projects.map(p => <option key={p.id} value={p.id}>{p.moldName}</option>)}
                                    </select>
                                    <input type="text" placeholder="Yeni Alt Parça Adı (Örn: ANA GÖVDE)" value={newTaskName} onChange={(e) => { setNewTaskName(e.target.value); setBatchError(''); }} className="rounded-lg border-gray-300 dark:bg-gray-700 dark:border-gray-600 dark:text-white px-3 py-2 col-span-4 md:col-span-2" />
                                    <button onClick={handleAddNewTask} className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition font-medium disabled:opacity-50 col-span-4 md:col-span-1" disabled={!selectedMoldId || !newTaskName}>
                                        Parça Ekle
                                    </button>
                                </div>
                            </div>

                            <div className="p-4 border border-purple-200 dark:border-purple-700 rounded-lg bg-purple-50 dark:bg-purple-900/10">
                                <h3 className="text-xl font-semibold dark:text-white mb-3 flex items-center"><Plus className="w-5 h-5 mr-2"/> Toplu Parça Ekle</h3>
                                <div className="space-y-4">
                                    <select value={selectedMoldId} onChange={(e) => { setSelectedMoldId(e.target.value); setBatchError(''); }} className="w-full rounded-lg border-gray-300 dark:bg-gray-700 dark:border-gray-600 dark:text-white px-3 py-2">
                                        <option value="">Kalıp Seçiniz</option>
                                        {projects.map(p => <option key={p.id} value={p.id}>{p.moldName}</option>)}
                                    </select>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                            Parça İsimleri (Her satıra bir parça)
                                        </label>
                                        <textarea
                                            value={batchTaskNames}
                                            onChange={(e) => { setBatchTaskNames(e.target.value); setBatchError(''); }}
                                            rows={6}
                                            placeholder={`Örnek:
ANA GÖVDE SOL
ANA GÖVDE SAĞ
SICAK YOLLUK
TEST PLAKASI
...`}
                                            className="w-full rounded-lg border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white px-3 py-2"
                                        />
                                        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                                            Her satıra bir parça ismi yazın. Boş satırlar göz ardı edilecektir.
                                        </p>
                                    </div>
                                    {batchError && (
                                        <div className={`flex items-center text-sm p-3 rounded-lg ${batchError.startsWith('ℹ️') ? 'text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/20' : 'text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-900/20'}`}>
                                            <AlertTriangle className="w-4 h-4 mr-2" />
                                            {batchError}
                                        </div>
                                    )}
                                    <button 
                                        onClick={handleBatchAddTasks} 
                                        className="w-full px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition font-medium disabled:opacity-50"
                                        disabled={!selectedMoldId || !batchTaskNames.trim()}
                                    >
                                        Toplu Parça Ekle ({batchTaskNames.split('\n').filter(name => name.trim().length > 0).length} parça)
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Sağ Taraf - Mevcut Parça Listesi */}
                        <div className="lg:col-span-1">
                            {selectedMold ? (
                                <TaskListSidebar 
                                    tasks={selectedMold.tasks.sort((a,b) => a.taskNumber - b.taskNumber)} // Sıralı göster
                                    onDeleteTask={handleDeleteTask} // Bu, ana TASK'ı siler
                                    selectedMoldId={selectedMoldId}
                                />
                            ) : (
                                <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 p-6 text-center">
                                    <List className="w-12 h-12 text-gray-400 dark:text-gray-600 mx-auto mb-3" />
                                    <p className="text-gray-500 dark:text-gray-400">
                                        Parça listesini görmek için bir kalıp seçin
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                </>
            ) : (
                <PersonnelManagement 
                    db={db} 
                    personnel={personnel} 
                    setPersonnel={setPersonnel}
                    machines={machines}
                    setMachines={setMachines}
                />
            )}
        </div>
    );
};
// --- (DÜZELTİLMİŞ) ADMIN DASHBOARD SONU ---

// GÜNCELLEME: Artık operasyonları listeliyor
const HistoryPage = ({ projects }) => {
     const completedOperations = useMemo(() => {
        return projects.flatMap(mold => 
            mold.tasks.flatMap(task => 
                task.operations
                    .filter(op => op.status === OPERATION_STATUS.COMPLETED)
                    .map(op => ({ 
                        ...op, 
                        moldName: mold.moldName,
                        taskName: task.taskName
                    }))
            )
        ).sort((a, b) => new Date(b.finishDate) - new Date(a.finishDate));
    }, [projects]);

    return (
        <div className="p-4 bg-white dark:bg-gray-800 rounded-xl shadow-xl">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">Geçmiş Tamamlanmış Operasyonlar ({completedOperations.length})</h2>
            
            {completedOperations.length === 0 ? (
                 <p className="text-gray-500 dark:text-gray-400">Şu ana kadar tamamlanmış operasyon bulunmamaktadır.</p>
            ) : (
                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                        <thead className="bg-gray-50 dark:bg-gray-700">
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-gray-300">Kalıp / Parça / Operasyon</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-gray-300">CAM Operatörü</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-gray-300">CAM -&gt; Tezgah Puanı</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-gray-300">Süre (Saat)</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-gray-300">Yetkili Puanı</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-gray-300">Yetkili Yorumu</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700">
                            {completedOperations.map(op => (
                                <tr key={op.id} className="hover:bg-gray-50 dark:hover:bg-gray-700/50 transition">
                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="text-sm font-medium text-gray-900 dark:text-white">{op.moldName}</div>
                                        <div className="text-xs text-gray-500 dark:text-gray-400">{op.taskName}</div>
                                        <div className="text-xs font-bold text-blue-600 dark:text-blue-400">{op.type}</div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">{op.assignedOperator}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-blue-600 dark:text-blue-400 font-semibold">{op.camOperatorRatingForMachineOp || 'N/A'}/10</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-green-600 dark:text-green-400 font-semibold">{op.durationInHours || 'N/A'}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-bold text-purple-600 dark:text-purple-400">{op.supervisorRating}/10</td>
                                    <td className="px-6 py-4 whitespace-normal text-xs text-gray-500 dark:text-gray-400 max-w-xs break-words">
                                        {op.supervisorComment || '---'}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

// --- GÜNCELLENMİŞ: ANALİZ SAYFASI ---
const AnalysisPage = ({ projects, personnel }) => {
    
    // ... (State'ler - değişiklik yok)
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedPersonnelId, setSelectedPersonnelId] = useState(null);

    // GÜNCELLEME: Tüm tamamlanmış *operasyonları* al
    const allCompletedOperations = useMemo(() => {
        return projects.flatMap(mold => 
            mold.tasks.flatMap(task => 
                task.operations
                    .filter(op => op.status === OPERATION_STATUS.COMPLETED)
                    .map(op => ({ 
                        ...op, 
                        moldName: mold.moldName,
                        taskName: task.taskName
                    }))
            )
        );
    }, [projects]);

    // ... (filteredPersonnel - değişiklik yok)
    const filteredPersonnel = useMemo(() => {
        const lowerSearchTerm = searchTerm.toLowerCase();
        return personnel.filter(p => 
            p.name.toLowerCase().includes(lowerSearchTerm) ||
            p.role.toLowerCase().includes(lowerSearchTerm)
        ).sort((a, b) => a.name.localeCompare(b.name));
    }, [personnel, searchTerm]);

    // GÜNCELLEME: Operasyonlara göre veri bul
    const selectedPersonnelData = useMemo(() => {
        if (!selectedPersonnelId) return null;
        
        const person = personnel.find(p => p.id === selectedPersonnelId);
        if (!person) return null;

        let relevantTasks = []; // Bu artık 'relevantOperations'
        let averageRating = 0;
        let totalRatings = 0;
        let ratingCount = 0;
        
        if (person.role === PERSONNEL_ROLES.CAM_OPERATOR || person.role === PERSONNEL_ROLES.SUPERVISOR || person.role === PERSONNEL_ROLES.ADMIN) {
            // CAM Operatörüyse, 'Yetkili Puanı'na bak
            relevantTasks = allCompletedOperations.filter(op => op.assignedOperator === person.name);
            relevantTasks.forEach(op => {
                if (op.supervisorRating) {
                    totalRatings += op.supervisorRating;
                    ratingCount++;
                }
            });
        } else if (person.role === PERSONNEL_ROLES.MACHINE_OPERATOR) {
            // Tezgah Operatörüyse, 'CAM'in Tezgah Op. Puanı'na bak
            relevantTasks = allCompletedOperations.filter(op => op.machineOperatorName === person.name);
            relevantTasks.forEach(op => {
                if (op.camOperatorRatingForMachineOp) {
                    totalRatings += op.camOperatorRatingForMachineOp;
                    ratingCount++;
                }
            });
        }
        
        if (ratingCount > 0) {
            averageRating = (totalRatings / ratingCount).toFixed(1);
        }

        return {
            ...person,
            completedTasks: relevantTasks.sort((a, b) => new Date(b.finishDate) - new Date(a.finishDate)), // 'completedOperations' olmalı
            averageRating: averageRating,
            ratingCount: ratingCount
        };

    }, [selectedPersonnelId, personnel, allCompletedOperations]);


    // --- Bileşenler ---

    // 1. Sol Taraf: Arama ve Personel Listesi
    const PersonnelSidebar = () => (
        <div className="w-full lg:w-1/3 xl:w-1/4 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg shadow-inner">
            <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">Personel Listesi</h3>
            <div className="relative mb-4">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
                <input
                    type="text"
                    placeholder="Personel ara..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
            </div>
            <div className="max-h-[60vh] overflow-y-auto">
                <div className="divide-y divide-gray-200 dark:divide-gray-700">
                    {filteredPersonnel.length === 0 ? (
                        <p className="p-4 text-sm text-center text-gray-500 dark:text-gray-400">Personel bulunamadı.</p>
                    ) : (
                        filteredPersonnel.map(person => (
                            <button
                                key={person.id}
                                onClick={() => setSelectedPersonnelId(person.id)}
                                className={`w-full text-left p-3 transition ${
                                    selectedPersonnelId === person.id 
                                        ? 'bg-blue-600 text-white rounded-lg' 
                                        : 'hover:bg-gray-200 dark:hover:bg-gray-700'
                                }`}
                            >
                                <p className="font-medium">{person.name}</p>
                                <p className={`text-sm ${selectedPersonnelId === person.id ? 'text-blue-200' : 'text-gray-500 dark:text-gray-400'}`}>
                                    {person.role}
                                </p>
                            </button>
                        ))
                    )}
                </div>
            </div>
        </div>
    );

    // 2. Sağ Taraf (Varsayılan): Genel Bakış Dashboard'u (GÜNCELLENDİ)
    const DashboardContent = () => {
        // Dashboard verilerini hesapla (operasyonlara göre)
        const dashboardData = useMemo(() => {
            const camOperatorData = {};
            const machineOperatorData = {};
            const monthlyCamData = {};
            
            const thirtyDaysAgo = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000);

            allCompletedOperations.forEach(op => {
                const camOp = op.assignedOperator;
                const machineOp = op.machineOperatorName;

                // 1. Yetkili -> CAM Puanları
                if (camOp && camOp !== 'SEÇ' && op.supervisorRating) {
                    if (!camOperatorData[camOp]) {
                        camOperatorData[camOp] = { total: 0, count: 0 };
                    }
                    camOperatorData[camOp].total += op.supervisorRating;
                    camOperatorData[camOp].count++;
                }

                // 2. CAM -> Tezgah Puanları
                if (machineOp && machineOp !== 'SEÇ' && op.camOperatorRatingForMachineOp) {
                     if (!machineOperatorData[machineOp]) {
                        machineOperatorData[machineOp] = { total: 0, count: 0 };
                    }
                    machineOperatorData[machineOp].total += op.camOperatorRatingForMachineOp;
                    machineOperatorData[machineOp].count++;
                }
                
                // 3. Aylık CAM Grafiği
                const finishDate = new Date(op.finishDate);
                if (camOp && camOp !== 'SEÇ' && finishDate >= thirtyDaysAgo) {
                    if (!monthlyCamData[camOp]) {
                        monthlyCamData[camOp] = 0;
                    }
                    monthlyCamData[camOp]++;
                }
            });
            
            const formatData = (data) => Object.fromEntries(
                Object.entries(data).map(([key, val]) => [key, (val.total / val.count).toFixed(1)])
            );

            return {
                camAverages: formatData(camOperatorData),
                machineOpAverages: formatData(machineOperatorData),
                monthlyCamCounts: monthlyCamData
            };
        }, [allCompletedOperations]);
        
        const maxMonthlyCount = Math.max(0, ...Object.values(dashboardData.monthlyCamCounts));

        return (
            <div className="space-y-6">
                <h3 className="text-2xl font-bold text-gray-900 dark:text-white">Performans Genel Bakış</h3>
                
                <div className="p-4 border rounded-lg dark:border-gray-700 bg-gray-50 dark:bg-gray-700/50">
                    <h4 className="text-lg font-semibold dark:text-white mb-3">Son 30 Günde Biten Operasyon Sayısı (CAM Operatörleri)</h4>
                    <div className="space-y-2">
                        {Object.keys(dashboardData.monthlyCamCounts).length === 0 ? (
                            <p className="text-sm text-gray-500 dark:text-gray-400">Son 30 günde tamamlanan operasyon yok.</p>
                        ) : (
                            Object.entries(dashboardData.monthlyCamCounts)
                                .sort((a, b) => b[1] - a[1])
                                .map(([operator, count]) => (
                                <div key={operator}>
                                    <div className="flex justify-between text-sm font-medium dark:text-gray-300 mb-1">
                                        <span>{operator}</span>
                                        <span>{count} operasyon</span>
                                    </div>
                                    <div className="w-full bg-gray-200 rounded-full h-4 dark:bg-gray-600">
                                        <div 
                                            className="bg-blue-600 h-4 rounded-full text-xs font-bold text-white text-center" 
                                            style={{ width: `${(count / (maxMonthlyCount || 1)) * 100}%` }}
                                        >
                                            {count}
                                        </div>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="p-4 border rounded-lg dark:border-gray-700 bg-gray-50 dark:bg-gray-700/50">
                        <h4 className="text-lg font-semibold dark:text-white mb-3">Tezgah Operatörü Puan Ortalamaları (CAM Puanlarına Göre)</h4>
                        <div className="space-y-2">
                            {Object.keys(dashboardData.machineOpAverages).length === 0 ? (
                                <p className="text-sm text-gray-500 dark:text-gray-400">Puanlanmış tezgah operatörü işi yok.</p>
                            ) : (
                                Object.entries(dashboardData.machineOpAverages).map(([operator, avg]) => (
                                    <div key={operator} className="flex justify-between items-center">
                                        <span className="font-medium dark:text-gray-300">{operator}</span>
                                        <span className="font-bold text-lg text-blue-600 dark:text-blue-400">{avg} / 10</span>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                    
                    <div className="p-4 border rounded-lg dark:border-gray-700 bg-gray-50 dark:bg-gray-700/50">
                        <h4 className="text-lg font-semibold dark:text-white mb-3">CAM Operatörü Puan Ortalamaları (Yetkili Puanlarına Göre)</h4>
                        <div className="space-y-2">
                             {Object.keys(dashboardData.camAverages).length === 0 ? (
                                <p className="text-sm text-gray-500 dark:text-gray-400">Puanlanmış CAM operatörü işi yok.</p>
                            ) : (
                                Object.entries(dashboardData.camAverages).map(([operator, avg]) => (
                                    <div key={operator} className="flex justify-between items-center">
                                        <span className="font-medium dark:text-gray-300">{operator}</span>
                                        <span className="font-bold text-lg text-purple-600 dark:text-purple-400">{avg} / 10</span>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    // 3. Sağ Taraf (Seçim Var): Detaylı Performans Raporu (GÜNCELLENDİ)
    const ReportContent = () => (
        <div className="space-y-6">
            <div className="flex justify-between items-start">
                <div>
                    <h3 className="text-2xl font-bold text-gray-900 dark:text-white">Performans Raporu: {selectedPersonnelData.name}</h3>
                    <p className="text-lg text-gray-600 dark:text-gray-400">{selectedPersonnelData.role}</p>
                </div>
                 <button 
                    onClick={() => setSelectedPersonnelId(null)}
                    className="text-sm text-blue-600 dark:text-blue-400 hover:underline"
                >
                    &larr; Genel Bakışa Dön
                </button>
            </div>
            
            <div className="grid grid-cols-2 gap-4">
                <div className="p-4 bg-gray-100 dark:bg-gray-700 rounded-lg">
                    <p className="text-sm text-gray-600 dark:text-gray-400">Toplam Tamamlanan Operasyon</p>
                    <p className="text-3xl font-bold text-gray-900 dark:text-white">{selectedPersonnelData.completedTasks.length}</p>
                </div>
                <div className="p-4 bg-gray-100 dark:bg-gray-700 rounded-lg">
                    <p className="text-sm text-gray-600 dark:text-gray-400">Puan Ortalaması</p>
                    <p className="text-3xl font-bold text-blue-600 dark:text-blue-400">
                        {selectedPersonnelData.ratingCount > 0 ? `${selectedPersonnelData.averageRating} / 10` : 'N/A'}
                    </p>
                </div>
            </div>

            <div>
                <h4 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">Tamamlanan Operasyon Dökümü ve Yorumlar</h4>
                <div className="space-y-4 max-h-[50vh] overflow-y-auto">
                    {selectedPersonnelData.completedTasks.length === 0 ? (
                        <p className="text-gray-500 dark:text-gray-400">Bu personel için tamamlanmış operasyon bulunmamaktadır.</p>
                    ) : (
                        selectedPersonnelData.completedTasks.map(op => ( // 'op' operasyon objesi
                            <div key={op.id} className="p-4 border rounded-lg dark:border-gray-700 bg-gray-50 dark:bg-gray-700/50">
                                <p className="font-semibold dark:text-white">{op.moldName} - {op.taskName}</p>
                                <p className="font-medium text-blue-600 dark:text-blue-400">{op.type}</p>
                                <p className="text-xs text-gray-500 dark:text-gray-400">Bitiş Tarihi: {formatDate(op.finishDate)}</p>
                                
                                <div className="mt-3 space-y-2">
                                    {/* CAM Operatörüyse: Yetkili Yorumu/Puanı */}
                                    {selectedPersonnelData.role === PERSONNEL_ROLES.CAM_OPERATOR && (
                                        <div className="p-2 bg-purple-100 dark:bg-purple-900/20 rounded-md">
                                            <p className="text-xs font-semibold text-purple-800 dark:text-purple-300">Yetkili Değerlendirmesi:</p>
                                            <p className="text-sm font-bold text-purple-700 dark:text-purple-300">Puan: {op.supervisorRating || 'N/A'} / 10</p>
                                            <p className="text-sm text-purple-700 dark:text-purple-300 italic">Yorum: "{op.supervisorComment || 'Yorum yok'}"</p>
                                        </div>
                                    )}
                                    
                                    {/* Tezgah Operatörüyse: CAM Yorumu/Puanı */}
                                     {selectedPersonnelData.role === PERSONNEL_ROLES.MACHINE_OPERATOR && (
                                        <div className="p-2 bg-blue-100 dark:bg-blue-900/20 rounded-md">
                                            <p className="text-xs font-semibold text-blue-800 dark:text-blue-300">CAM Değerlendirmesi ({op.assignedOperator}):</p>
                                            <p className="text-sm font-bold text-blue-700 dark:text-blue-300">Puan: {op.camOperatorRatingForMachineOp || 'N/A'} / 10</p>
                                            <p className="text-sm text-blue-700 dark:text-blue-300 italic">Yorum: "{op.camOperatorCommentForMachineOp || 'Yorum yok'}"</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );

    return (
        <div className="p-4 bg-white dark:bg-gray-800 rounded-xl shadow-xl">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">Performans Merkezi</h2>
            
            <div className="flex flex-col lg:flex-row gap-6">
                <PersonnelSidebar />
                <div className="flex-1">
                    {selectedPersonnelId ? <ReportContent /> : <DashboardContent />}
                </div>
            </div>
        </div>
    );
};
// --- GÜNCELLENMİŞ ANALİZ SAYFASI SONU ---


// --- UTILITIES ---

const calculateDurationInHours = (start, end) => {
    // ... (Mevcut fonksiyon - değişiklik yok)
    if (!start || !end) return null;
    try {
        const startDate = new Date(start);
        const endDate = new Date(end);
        if (isNaN(startDate) || isNaN(endDate)) return null;
        const diffTime = Math.abs(endDate - startDate);
        return (diffTime / (1000 * 60 * 60)).toFixed(1);
    } catch (e) {
        console.error("Süre hesaplama hatası:", e);
        return null;
    }
};

// GÜNCELLEME: Artık kullanılmıyor
// const getMoldStatusFromTasks = (tasks) => { ... };

/**
 * Navigation Component
 */
const NavItem = ({ icon: Icon, label, isActive, onClick, role, taskCount }) => {
    // ... (Mevcut bileşen - değişiklik yok)
    const showCount = (label === 'Değerlendirme') && taskCount > 0;
    
    return (
        <button
            onClick={onClick}
            className={`flex items-center space-x-2 px-3 py-2 rounded-lg transition-colors duration-150 relative ${
                isActive
                    ? 'bg-blue-600 text-white shadow-lg'
                    : 'text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'
            }`}
        >
            <Icon className="w-5 h-5" />
            <span className="font-medium">{label}</span>
             {showCount && (
                <span className="ml-auto inline-flex items-center justify-center px-2 py-0.5 text-xs font-bold leading-none text-white bg-red-600 rounded-full absolute -top-1 -right-1">
                    {taskCount}
                </span>
            )}
        </button>
    );
};

/**
 * YENİ: Gerçek Giriş Ekranı (Kullanıcı Adı / Şifre ile)
 */
const CredentialLoginScreen = ({ db, setLoggedInUser, personnel }) => {
    // ... (Mevcut bileşen - değişiklik yok)
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const handleLogin = async () => {
        if (!username || !password) {
            setError('Kullanıcı adı ve şifre zorunludur.');
            return;
        }
        setLoading(true);
        setError('');

        try {
            const lowerCaseUsername = username.trim().toLowerCase();
            const userData = personnel.find(p => p.username === lowerCaseUsername);

            if (!userData) {
                setError('Kullanıcı bulunamadı.');
                setLoading(false);
                return;
            }
            if (userData.password === password) {
                setLoggedInUser({ ...userData });
            } else {
                setError('Hatalı şifre.');
            }
        } catch (err) {
            console.error("Giriş hatası:", err);
            setError('Giriş sırasında bir hata oluştu.');
        }
        setLoading(false);
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900 p-4">
            <div className="w-full max-w-md bg-white dark:bg-gray-800 p-8 rounded-xl shadow-2xl">
                <h2 className="text-3xl font-bold text-center text-gray-900 dark:text-white mb-6">
                    Kalıphane Takip Sistemi
                </h2>
                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                            Kullanıcı Adı
                        </label>
                        <div className="relative">
                            <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                                <User className="w-5 h-5 text-gray-400" />
                            </span>
                            <input
                                type="text"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                placeholder="kullanici.adi"
                                className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                            Şifre
                        </label>
                        <div className="relative">
                            <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                                <Lock className="w-5 h-5 text-gray-400" />
                            </span>
                            <input
                                type={showPassword ? 'text' : 'password'}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="••••••••"
                                className="w-full pl-10 pr-10 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500"
                            />
                            <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
                            >
                                {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                            </button>
                        </div>
                    </div>

                    {error && (
                        <div className="p-3 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-700 rounded-lg text-sm text-red-700 dark:text-red-300 flex items-center">
                            <AlertTriangle className="w-4 h-4 mr-2" />
                            {error}
                        </div>
                    )}

                </div>
                <button
                    onClick={handleLogin}
                    disabled={loading}
                    className="w-full flex justify-center py-2 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition duration-150 mt-6 disabled:opacity-50"
                >
                    {loading ? <RefreshCw className="w-5 h-5 animate-spin" /> : <LogOut className="w-5 h-5 mr-2 rotate-180"/>}
                    {loading ? 'Giriş Yapılıyor...' : 'Giriş Yap'}
                </button>
            </div>
            <p className="mt-4 text-xs text-red-500 dark:text-red-400 text-center max-w-md">
                <AlertTriangle className="w-4 h-4 inline mr-1" />
                Bu sistem, şifreleri güvensiz (şifrelenmemiş) olarak saklamaktadır. Bu yalnızca bir demo/prototip içindir.
            </p>
        </div>
    );
};


// --- MAIN APP COMPONENT ---

const App = () => {
    const [db, setDb] = useState(null);
    const [userId, setUserId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isProjectsLoading, setIsProjectsLoading] = useState(true);
    const [projects, setProjects] = useState([]);
    const [personnel, setPersonnel] = useState([]);
    const [machines, setMachines] = useState([]);
    const [currentPage, setCurrentPage] = useState('list');
    const [selectedMold, setSelectedMold] = useState(null);
    const [loggedInUser, setLoggedInUser] = useState(null);

    // GÜNCELLEME: Kalıp durumu hesaplaması (Sadece seed için)
    const getMoldStatusFromTasksForSeed = (tasks) => {
        // ... (Mevcut fonksiyon - değişiklik yok)
        if (!tasks || tasks.length === 0) {
            return OPERATION_STATUS.NOT_STARTED;
        }
        // GÜNCELLEME: Operasyonları kontrol et
        const allOps = tasks.flatMap(t => t.operations || []); // Henüz migrate edilmemişse operations olmayabilir
        if (allOps.length === 0) {
             // Eski yapı, task'ın kendisini kontrol et
             if (tasks.every(t => t.status === OPERATION_STATUS.COMPLETED)) return OPERATION_STATUS.COMPLETED;
             if (tasks.some(t => [OPERATION_STATUS.IN_PROGRESS, OPERATION_STATUS.WAITING_SUPERVISOR_REVIEW].includes(t.status))) return OPERATION_STATUS.IN_PROGRESS;
             if (tasks.every(t => t.status === OPERATION_STATUS.NOT_STARTED)) return OPERATION_STATUS.NOT_STARTED;
             return OPERATION_STATUS.IN_PROGRESS;
        }

        if (allOps.every(op => op.status === OPERATION_STATUS.COMPLETED)) {
            return OPERATION_STATUS.COMPLETED;
        }
        if (allOps.some(op => [OPERATION_STATUS.IN_PROGRESS, OPERATION_STATUS.WAITING_SUPERVISOR_REVIEW].includes(op.status))) {
            return OPERATION_STATUS.IN_PROGRESS;
        }
        if (allOps.every(op => op.status === OPERATION_STATUS.NOT_STARTED)) {
            return OPERATION_STATUS.NOT_STARTED;
        }
        return OPERATION_STATUS.IN_PROGRESS;
    };
    
    // 3. Başlangıç Verilerini Kontrol Etme ve Ekleme (GÜNCELLENDİ: VERİ MİGRASYONU)
    const seedInitialData = useCallback(async () => {
        if (!db) return;
        
        // Projeleri kontrol et
        const q = query(collection(db, PROJECT_COLLECTION));
        const querySnapshot = await getDocs(q);

        if (querySnapshot.empty) {
            console.log("Firestore boş, örnek projeler (yeni operasyon yapısıyla) ekleniyor...");
            for (const project of initialProjects) {
                await setDoc(doc(db, PROJECT_COLLECTION, project.id), { 
                    ...project, 
                    status: project.status,
                });
            }
            console.log("Örnek projeler eklendi.");
        } else {
             console.log("Mevcut projeler kontrol ediliyor (migrasyon ve eksik alanlar için)...");
            for (const docSnapshot of querySnapshot.docs) {
                const project = docSnapshot.data();
                let updates = {};
                let needsMigration = false;
                
                // 1. Veri Migrasyonu (task -> operation)
                const migratedTasks = project.tasks.map(task => {
                    if (task.operations === undefined) { // Migrasyon gerekli
                        needsMigration = true;
                        console.log(`Migrasyon gerekli: ${project.moldName} -> ${task.taskName}`);
                        
                        // Eski task objesinden operasyon objesi oluştur
                        const cncOperation = {
                            id: task.id || `op-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`, // ID'yi koru veya yeni oluştur
                            type: OPERATION_TYPES.CNC,
                            status: task.status,
                            progressPercentage: task.progressPercentage,
                            assignedOperator: task.assignedOperator,
                            machineName: task.machineName,
                            machineOperatorName: task.machineOperatorName,
                            estimatedDueDate: task.estimatedDueDate,
                            startDate: task.startDate,
                            finishDate: task.finishDate,
                            durationInHours: task.durationInHours,
                            supervisorRating: task.supervisorRating,
                            supervisorReviewDate: task.supervisorReviewDate,
                            supervisorComment: task.supervisorComment,
                            camOperatorRatingForMachineOp: task.camOperatorRatingForMachineOp,
                            camOperatorCommentForMachineOp: task.camOperatorCommentForMachineOp,
                            camOperatorReviewDate: task.camOperatorReviewDate
                        };
                        
                        // Yeni task objesini oluştur
                        return {
                            id: task.id, // Ana task ID'sini koru
                            taskName: task.taskName,
                            taskNumber: task.taskNumber,
                            operations: [cncOperation] // Yeni operasyon dizisi
                        };
                    }
                    return task; // Zaten yeni yapıda
                });

                if (needsMigration) {
                    updates.tasks = migratedTasks;
                    console.log(`Migrasyon ${project.moldName} için tamamlandı.`);
                }

                // 2. Eksik Alan Kontrolü (status, moldDeadline)
                if (project.status === undefined || project.status === 'AKTİF') {
                    const calculatedTaskStatus = getMoldStatusFromTasksForSeed(migratedTasks); // Migre edilmiş task'ları kullan
                    updates.status = mapTaskStatusToMoldStatus(calculatedTaskStatus);
                    console.log(`Eksik/Eski 'status' alanı ${project.moldName} için güncellendi: ${updates.status}`);
                }
                
                if (project.moldDeadline === undefined) {
                    updates.moldDeadline = '';
                    console.log(`Eksik 'moldDeadline' alanı ${project.moldName} için eklendi.`);
                }

                if(Object.keys(updates).length > 0) {
                     await updateDoc(doc(db, PROJECT_COLLECTION, project.id), updates);
                }
            }
        }

        // Personel koleksiyonunu kontrol et
        const personnelQuery = query(collection(db, PERSONNEL_COLLECTION), where("username", "==", "admin"));
        const adminUserSnapshot = await getDocs(personnelQuery);

        if (adminUserSnapshot.empty) {
            console.log("Admin kullanıcısı bulunamadı, personel koleksiyonu (yeniden) oluşturuluyor...");

            const allPersonnelQuery = query(collection(db, PERSONNEL_COLLECTION));
            const allPersonnelSnapshot = await getDocs(allPersonnelQuery);
            if (!allPersonnelSnapshot.empty) {
                console.log("Eski personel verisi siliniyor...");
                for (const docSnapshot of allPersonnelSnapshot.docs) {
                    await deleteDoc(doc(db, PERSONNEL_COLLECTION, docSnapshot.id));
                }
                console.log("Eski personel verisi silindi.");
            }
            
            const samplePersonnel = [
                { id: 'person-admin', name: 'Ayşe Hanım (Yönetici)', role: PERSONNEL_ROLES.ADMIN, createdAt: getCurrentDateTimeString(), username: 'admin', password: '123' },
                { id: 'person-cam1', name: 'Emre Bey (CAM)', role: PERSONNEL_ROLES.CAM_OPERATOR, createdAt: getCurrentDateTimeString(), username: 'emre', password: '123' },
                { id: 'person-cam2', name: 'Can Bey (CAM)', role: PERSONNEL_ROLES.CAM_OPERATOR, createdAt: getCurrentDateTimeString(), username: 'can', password: '123' },
                { id: 'person-sup1', name: 'Fatma Hanım (Yetkili)', role: PERSONNEL_ROLES.SUPERVISOR, createdAt: getCurrentDateTimeString(), username: 'fatma', password: '123' },
                { id: 'person-machine1', name: 'Ali Yılmaz', role: PERSONNEL_ROLES.MACHINE_OPERATOR, createdAt: getCurrentDateTimeString(), username: null, password: null },
                { id: 'person-machine2', name: 'Burak Demir', role: PERSONNEL_ROLES.MACHINE_OPERATOR, createdAt: getCurrentDateTimeString(), username: null, password: null },
                { id: 'person-machine3', name: 'Deniz Kaya', role: PERSONNEL_ROLES.MACHINE_OPERATOR, createdAt: getCurrentDateTimeString(), username: null, password: null },
            ];
            
            for (const person of samplePersonnel) {
                await setDoc(doc(db, PERSONNEL_COLLECTION, person.id), person);
            }
            console.log("Örnek personel eklendi (kullanıcı adı ve şifrelerle).");
        }

        // Tezgah koleksiyonunu kontrol et
        const machinesQuery = query(collection(db, MACHINES_COLLECTION));
        const machinesSnapshot = await getDocs(machinesQuery);
        if (machinesSnapshot.empty) {
            console.log("Tezgah koleksiyonu boş, örnek veriler ekleniyor...");
            for (const machine of AVAILABLE_MACHINES) {
                const machineId = `machine-${machine}`;
                await setDoc(doc(db, MACHINES_COLLECTION, machineId), {
                    id: machineId,
                    name: machine,
                    createdAt: getCurrentDateTimeString()
                });
            }
        }
    }, [db]);


    // 1. Firebase Başlatma ve (Anonim) Kimlik Doğrulama
    useEffect(() => {
        // ... (Mevcut fonksiyon - değişiklik yok)
        try {
            const app = initializeApp(firebaseConfig);
            const firestore = getFirestore(app);
            const firebaseAuth = getAuth(app);
            setDb(firestore);

            const authenticate = async () => {
                 if (initialAuthToken) {
                    try {
                        await signInWithCustomToken(firebaseAuth, initialAuthToken);
                        console.log("Custom token ile giriş yapıldı.");
                    } catch (error) {
                        console.error("Özel kimlik doğrulama hatası, anonim oturum açılıyor:", error);
                        await signInAnonymously(firebaseAuth);
                        console.log("Anonim olarak giriş yapıldı.");
                    }
                } else {
                    await signInAnonymously(firebaseAuth);
                    console.log("Anonim olarak giriş yapıldı.");
                }
            };
            
            const unsubscribe = onAuthStateChanged(firebaseAuth, (user) => {
                if (!user) {
                   authenticate();
                } else {
                    setUserId(user.uid);
                }
            });

            return () => unsubscribe();
        } catch (error) {
            console.error("Firebase başlatılırken bir hata oluştu:", error);
            setLoading(false);
        }
    }, []);

    // 2. Personel ve Tezgah verilerini dinleme (GÜNCELLENDİ)
    useEffect(() => {
        // ... (Mevcut fonksiyon - seedInitialData'yı çağırıyor)
        if (!db || !userId) return;

        let personnelListenerFired = false;
        let machinesListenerFired = false;
        let dataSeeded = false;

        const checkCoreLoadingDone = async () => {
            if (personnelListenerFired && machinesListenerFired && !dataSeeded) {
                dataSeeded = true;
                await seedInitialData();
                setLoading(false);
            }
        };

        const personnelQuery = query(collection(db, PERSONNEL_COLLECTION));
        const unsubscribePersonnel = onSnapshot(personnelQuery, (snapshot) => {
            const personnelData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setPersonnel(personnelData);
            personnelListenerFired = true;
            checkCoreLoadingDone();
        }, (error) => { 
            console.error("Personel dinleme hatası:", error);
            personnelListenerFired = true;
            checkCoreLoadingDone();
        });

        const machinesQuery = query(collection(db, MACHINES_COLLECTION));
        const unsubscribeMachines = onSnapshot(machinesQuery, (snapshot) => {
            const machinesData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setMachines(machinesData);
            machinesListenerFired = true;
            checkCoreLoadingDone();
        }, (error) => { 
            console.error("Tezgah dinleme hatası:", error);
            machinesListenerFired = true;
            checkCoreLoadingDone();
        });

        return () => {
            unsubscribePersonnel();
            unsubscribeMachines();
        };
    }, [db, userId, seedInitialData]);
    
    // 4. Proje Verilerini Gerçek Zamanlı Dinleme
    useEffect(() => {
        // ... (Mevcut fonksiyon - değişiklik yok)
        if (!db || !userId || !loggedInUser) return;
        
        setIsProjectsLoading(true);
        const q = query(collection(db, PROJECT_COLLECTION));

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const newProjects = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
            newProjects.sort((a, b) => a.moldName.localeCompare(b.moldName));
            setProjects(newProjects);
            setIsProjectsLoading(false);
        }, (error) => { 
            console.error("Proje dinleme hatası:", error);
            setIsProjectsLoading(false);
        });

        return () => unsubscribe();
    }, [db, userId, loggedInUser]);
    
    // GÜNCELLEME: Merkezi Operasyon Güncelleme Fonksiyonu
    const handleUpdateOperation = useCallback(async (moldId, taskId, updatedOperationData) => {
        if (!db) return;

        const moldRef = doc(db, PROJECT_COLLECTION, moldId);
        const currentProject = projects.find(p => p.id === moldId);

        if (!currentProject) {
            console.error("Proje bulunamadı:", moldId);
            return;
        }

        const taskIndex = currentProject.tasks.findIndex(t => t.id === taskId);
        if (taskIndex === -1) {
            console.error("Güncellenecek görev bulunamadı:", taskId);
            return;
        }

        const currentTask = currentProject.tasks[taskIndex];
        const operationIndex = currentTask.operations.findIndex(op => op.id === updatedOperationData.id);
        if (operationIndex === -1) {
            console.error("Güncellenecek operasyon bulunamadı:", updatedOperationData.id);
            return;
        }

        // Operasyonu güncelle
        const newOperations = [...currentTask.operations];
        newOperations[operationIndex] = updatedOperationData;
        
        // Task'ı güncelle
        const newTasks = [...currentProject.tasks];
        newTasks[taskIndex] = { ...currentTask, operations: newOperations };

        try {
            await updateDoc(moldRef, {
                tasks: newTasks,
            });
            console.log(`Operasyon ${updatedOperationData.type} başarıyla güncellendi.`);
        } catch (e) {
            console.error("Operasyon güncelleme hatası: ", e);
        }
    }, [db, projects]);

    // YENİ: Yeni Operasyon Ekleme Fonksiyonu
    const handleAddOperation = useCallback(async (moldId, taskId, newOperationData) => {
        if (!db) return;

        const moldRef = doc(db, PROJECT_COLLECTION, moldId);
        const currentProject = projects.find(p => p.id === moldId);
        if (!currentProject) {
            console.error("Proje bulunamadı:", moldId);
            return;
        }

        const taskIndex = currentProject.tasks.findIndex(t => t.id === taskId);
        if (taskIndex === -1) {
            console.error("Güncellenecek görev bulunamadı:", taskId);
            return;
        }
        
        const currentTask = currentProject.tasks[taskIndex];
        
        // Operasyonu ekle
        const newOperations = [...currentTask.operations, newOperationData];
        
        // Task'ı güncelle
        const newTasks = [...currentProject.tasks];
        newTasks[taskIndex] = { ...currentTask, operations: newOperations };

        try {
            await updateDoc(moldRef, {
                tasks: newTasks,
            });
            console.log(`Operasyon ${newOperationData.type} başarıyla eklendi.`);
        } catch (e) {
            console.error("Operasyon ekleme hatası: ", e);
        }
    }, [db, projects]);


    // YENİ: Kalıp Ana Durumunu Güncelleme Fonksiyonu
    const handleUpdateMoldStatus = useCallback(async (moldId, newStatus) => {
        // ... (Mevcut fonksiyon - değişiklik yok)
        if (!db) return;
        const moldRef = doc(db, PROJECT_COLLECTION, moldId);
        try {
            await updateDoc(moldRef, { status: newStatus });
            console.log(`Kalıp ${moldId} durumu güncellendi: ${newStatus}`);
        } catch (e) {
            console.error("Kalıp durumu güncelleme hatası: ", e);
        }
    }, [db]);
    
    // YENİ: Kalıp Termin Tarihini Güncelleme Fonksiyonu
    const handleUpdateMoldDeadline = useCallback(async (moldId, newDeadline) => {
        // ... (Mevcut fonksiyon - değişiklik yok)
        if (!db) return;
        const moldRef = doc(db, PROJECT_COLLECTION, moldId);
        try {
            await updateDoc(moldRef, { moldDeadline: newDeadline });
            console.log(`Kalıp ${moldId} termini güncellendi: ${newDeadline}`);
        } catch (e) {
            console.error("Kalıp termin güncelleme hatası: ", e);
        }
    }, [db]);


    // GÜNCELLEME: Değerlendirme Bekleyen *Operasyon* Sayısı
    const tasksWaitingSupervisorReviewCount = useMemo(() => {
        return projects.flatMap(p => p.tasks.flatMap(t => t.operations))
                       .filter(op => op.status === OPERATION_STATUS.WAITING_SUPERVISOR_REVIEW).length;
    }, [projects]);

    // 7. Navigasyon öğelerini role göre filtrele
    const navItems = useMemo(() => {
        // ... (Mevcut fonksiyon - değişiklik yok)
        if (!loggedInUser) return [];
        const baseItems = [
            { id: 'list', label: 'Kalıp Listesi', icon: List, roles: Object.values(ROLES) },
            { id: 'active', label: 'Çalışan Parçalar', icon: PlayCircle, roles: Object.values(ROLES) },
            { id: 'cam', label: 'CAM İşlerim', icon: Settings, roles: [ROLES.CAM_OPERATOR] },
            { id: 'review', label: 'Değerlendirme', icon: CheckCircle, roles: [ROLES.SUPERVISOR] },
            { id: 'admin', label: 'Admin Paneli', icon: LayoutDashboard, roles: [ROLES.ADMIN] },
            { id: 'history', label: 'Geçmiş İşler', icon: History, roles: [ROLES.ADMIN, ROLES.SUPERVISOR] },
            { id: 'analysis', label: 'Analiz', icon: BarChart2, roles: [ROLES.ADMIN, ROLES.SUPERVISOR] },
        ];
        return baseItems.filter(item => item.roles.includes(loggedInUser.role));
    }, [loggedInUser]);

    // 8. Sayfa içeriğini render etme
    const renderPage = () => {
        if (selectedMold) {
            const currentSelectedMold = projects.find(p => p.id === selectedMold.id) || selectedMold;
            
            return <MoldDetailPage 
                        mold={currentSelectedMold} 
                        onBack={() => setSelectedMold(null)} 
                        loggedInUser={loggedInUser} 
                        handleUpdateOperation={handleUpdateOperation} // GÜNCEL
                        handleAddOperation={handleAddOperation} // YENİ
                        handleUpdateMoldStatus={handleUpdateMoldStatus}
                        handleUpdateMoldDeadline={handleUpdateMoldDeadline}
                        projects={projects} 
                        personnel={personnel} 
                        machines={machines}
                        db={db}
                    />;
        }

        switch (currentPage) {
            case 'list':
                return <EnhancedMoldList projects={projects} onSelectMold={setSelectedMold} />;
            case 'active': 
                return <ActiveTasksPage projects={projects} machines={machines} loggedInUser={loggedInUser} personnel={personnel} />;
            case 'cam':
                return <CamDashboard loggedInUser={loggedInUser} projects={projects} handleUpdateOperation={handleUpdateOperation} personnel={personnel} machines={machines} />;
            case 'review':
                return <SupervisorReviewPage loggedInUser={loggedInUser} projects={projects} handleUpdateOperation={handleUpdateOperation} />;
            case 'admin':
                return <AdminDashboard db={db} projects={projects} setProjects={setProjects} personnel={personnel} setPersonnel={setPersonnel} machines={machines} setMachines={setMachines} />;
            case 'history':
                return <HistoryPage projects={projects} />;
            case 'analysis':
                return <AnalysisPage projects={projects} personnel={personnel} />;
            default:
                return <EnhancedMoldList projects={projects} onSelectMold={setSelectedMold} />;
        }
    };

    // --- YENİ RENDER MANTIĞI ---

    // 1. Firebase (anonim) auth bekleniyor
    if (!userId || !db) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
                <RefreshCw className="w-8 h-8 text-blue-500 animate-spin" />
                <p className="ml-3 text-lg text-gray-600 dark:text-gray-400">Kimlik doğrulanıyor...</p>
            </div>
        );
    }

    // 2. Auth tamam, *Çekirdek Veri* (personel, makineler) bekleniyor
    if (loading) {
         return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
                <RefreshCw className="w-8 h-8 text-blue-500 animate-spin" />
                <p className="ml-3 text-lg text-gray-600 dark:text-gray-400">Personel verisi yükleniyor...</p> 
            </div>
        );
    }

    // 3. Çekirdek veri tamam, *Özel Giriş* (şifre) bekleniyor
    if (!loggedInUser) {
        return <CredentialLoginScreen db={db} setLoggedInUser={setLoggedInUser} personnel={personnel} />;
    }
    
    // 4. Özel giriş yapıldı, *Projeler* yükleniyor
    if (isProjectsLoading) {
         return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
                <RefreshCw className="w-8 h-8 text-blue-500 animate-spin" />
                <p className="ml-3 text-lg text-gray-600 dark:text-gray-400">Sistem verileri yükleniyor...</p>
            </div>
        );
    }

    // 5. Her şey hazır, ana uygulama
    return (
        <div className="p-4 sm:p-8 min-h-screen bg-gray-100 dark:bg-gray-900 font-sans">
            <header className="mb-8 border-b pb-4 dark:border-gray-700">
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center">
                    <h1 className="text-3xl font-extrabold text-gray-900 dark:text-white">Kalıphane İş Akışı Takibi</h1>
                    <div className="mt-4 sm:mt-0 flex items-center space-x-3">
                        <span className="text-sm font-medium text-blue-600 dark:text-blue-400">
                            Giriş Yapan: {loggedInUser.name} ({loggedInUser.role})
                        </span>
                        <button
                            onClick={() => {setLoggedInUser(null); setSelectedMold(null); setCurrentPage('list');}}
                            className="flex items-center text-sm px-3 py-1 bg-red-500 text-white rounded-lg hover:bg-red-600 transition"
                        >
                            <LogOut className="w-4 h-4 mr-1"/> Çıkış
                        </button>
                    </div>
                </div>

                <nav className="mt-4 flex flex-wrap gap-2">
                    {navItems.map(item => {
                        let taskCount = 0;
                        if (item.id === 'review') {
                            taskCount = tasksWaitingSupervisorReviewCount;
                        }

                        return (
                            <NavItem
                                key={item.id}
                                icon={item.icon}
                                label={item.label}
                                isActive={currentPage === item.id}
                                onClick={() => {setCurrentPage(item.id); setSelectedMold(null);}}
                                role={loggedInUser.role}
                                taskCount={taskCount}
                            />
                        );
                    })}
                </nav>
            </header>

            {/* Main Content Area */}
            {renderPage()}
            
            <footer className="mt-8 text-center text-xs text-gray-500 dark:text-gray-600 border-t pt-4 dark:border-gray-700">
                Veritabanı Kimliği: {userId} | Uygulama ID: {appId}
            </footer>
        </div>
    );
};

export default App;